/* eslint-disable max-lines */
/* eslint-disable sonarjs/no-duplicate-string */
// Todo: remove eslint and fix error

import {
  AddNewEmployeeAPi,
  AuthenticationApi,
  BasicInfoApi,
  CategoryApi,
  CertificateListApi,
  CertificateTypeApi,
  EmployeeAssetsApi,
  EmployeeAttendanceReportApi,
  EmployeeCertificationsApi,
  EmployeeDesignationListApi,
  EmployeeGeneralInformationApi,
  EmployeeHandbookSettingsApi,
  EmployeeListApi,
  EmployeeProjectsApi,
  EmployeeQualificationCategoryApi,
  EmployeeQualificationsApi,
  EmployeeReporteesApi,
  EmployeeReviewsApi,
  EmployeeSkillApi,
  PersonalInfoApi,
  ProfileHistoryApi,
  ShiftConfigurationApi,
  SideMenuApi,
  SkillApi,
  UserAccessToFeaturesApi,
  UserRolesConfigurationApi,
  EmployeeReportApi,
  EmployeeDesignationReportApi,
  VisaListApi,
  EmployeeHandbook,
  DisplayHandbook,
  TimeInOfficeReportApi,
  EmployeeLeaveSettingsApi,
  HiveActivityReportApi,
  EmployeeMailConfigurationApi,
  AddNewTemplateApi,
  ApplyLeaveApi,
  ScheduledInterviewsApi,
  AddNewMailTemplateTypeApi,
  MyAttendanceApi,
  LeaveReportsApi,
  TicketReportApi,
  ClientsApi,
  ProjectManagementApi,
  AddNewClientApi,
  ClientInformationApi,
  LeaveSummaryApi,
  TicketListInformationApi,
  TicketApprovalsApi,
  RaiseNewTicketApi,
  DashboardApi,
  UpdateTicketApi,
  BookingListApi,
  EventTypeListApi,
  EmployeeAllocationApi,
  AddLocationListApi,
  NewBookingApi,
  EventListApi,
  AddTrackerApi,
  AllocateEmployeeApi,
  AppraisalConfigurationsApi,
  RoomListApi,
  AssignTemplateApi,
  AddConfigurationsApi,
  TicketConfigurationApi,
  NewEventApi,
  SubmitResignationApi,
  LeaveApprovalsApi,
  ITDeclarationFormApi,
  PaySlipsApi,
  BankDetailsApi,
  PanDetailsApi,
  ResignationListApi,
  EmployeeAccountsApi,
  ITDeclarationListApi,
  InvestmentCheckListApi,
  AchieverListApi,
  CommonAchievementsApi,
  ProjectCreationRequestApi,
  AddAchieverApi,
  ProjectDetailsApi,
  ProjectTimeLineApi,
  ProjectChangeRequestApi,
  ProjectMilestoneApi,
  ProjectInvoiceApi,
  ProjectTailoringApi,
  ProjectTimeSheetApi,
  ProjectProposalApi,
  ProjectNotesApi,
  InitiateCycleApi,
  MyKRAsApi,
  NomineeListApi,
  AddNomineeApi,
  MyReviewApi,
  LeadershipEnrollmentFormApi,
  PIPListApi,
  LeadershipEnrollmentListApi,
  KRAApi,
  AddProjectCreationRequestApi,
  PayrollManagementApi,
  ReviewListApi,
  AppraisalTemplateApi,
  ProjectStatusApi,
  ProcessAreaListApi,
  AddNewAudit,
  SQAAuditReportApi,
  NotificationsApi,
  JobOpeningsApi,
  IntervieweeDetailsApi,
  CandidateListApi,
  VendorListApi,
  ChangeReporteesApi,
  ManufacturerApi,
  ProductTypeListApi,
  AssetWarrantyReportApi,
  CategoryListApi,
  AssetListApi,
  AssetTransationListApi,
  ChangeAssetStatusReportApi,
  ProductSpecificationListApi,
  AddAssetListApi,
  CreditCardListApi,
  MyProfileSeparationApi,
  ExpenseSubCategoryListApi,
  ProfileRecruitmentHistoryApi,
  UpComingJoinListApi,
  CompaniesListApi,
  CandidateOfferApi,
  InterviewStatusReportApi,
  PaymentListApi,
  ExpenseFormApi,
  ChecklistApi,
  ExpensesListApi,
  ExpenseYearlyReport,
  SectionsApi,
  ExpensesTimeLineApi,
  RemittanceApi,
  AdderessListApi,
  ClientInvoiceReport,
  LocationInvoiceListApi,
  addBankListApi,
  AddInvoiceApi,
  addTaxListApi,
  countryApi,
  ProjectNumbersTab,
  invoiceTimeLineApi,
  invoiceDiscussionListApi,
  AuditLogInvoiceListApi,
  GetInitDataApi,
  invoiceAuditReportApi,
  ProjectMilestonesApi,
  invoiceListApi,
  InvoicesSendReminderListApi,
  InvoiceSummaryApi,
  InvoicesReportListApi,
  InvoiceVersionListApi,
  EditProjectCreationRequestApi,
  VpnAttendanceApi,
  EmployeeProfileApi,
  ShortFAllApi,
  InternDetailsApi,
  InsuranceApi,
  AccessCardDetailsApi,
  AppraisalCardUploadAPI,
  LateArrivalReportApi,
  AttendanceRegularizationApi,
  ApplyLateArrivalApi,
  PmoConfigurationApi,
  formSixteenDownloadApi,
  formSixteenUploadApi,
  ComplianceReminderApi,
  ProjectClosureRequestApi,
  ResumeMatcherApi,
  NewYearPopupApi,
  InterviewerConfigurationApi,
  SowApi,
  ObservationApi,
} from '../../types/apiTypes'
import { festivalUploadApi } from '../../types/Settings/FestivalManagement/FestivalManagementType'

const fallbackApiBaseUrl = 'https://ovhdotnet.raybiztech.com'
const envApiBaseUrl = (
  process.env.REACT_APP_API_BASE || fallbackApiBaseUrl
).trim()
const baseUrl = envApiBaseUrl.replace(
  'ovhadmin.raybiztech.com',
  'ovhdotnet.raybiztech.com',
)
const apiPrefix = baseUrl + '/hrm-ws'

const aiApiPrefix =
  'https://ovh-resume-webapp-prod-dadvh3bdf4byaabn.centralindia-01.azurewebsites.net'

export enum AllowedHttpMethods {
  get = 'get',
  post = 'post',
  update = 'update',
  delete = 'delete',
  put = 'put',
}

export enum ApiLoadingState {
  idle = 'idle',
  loading = 'loading',
  pending = 'pending',
  succeeded = 'succeeded',
  failed = 'failed',
  success = 'success',
  Loaded = 'Loaded',
}

export const authenticationApiConfig: AuthenticationApi = {
  login: apiPrefix + '/auth/login',
  logout: apiPrefix + '/user/logoutUser',
  vendorUpdatePassword: apiPrefix + '/assetManagement/updateVendorPassword',
}

export const sideMenuApiConfig: SideMenuApi = {
  getMenuData: apiPrefix + '/roleFeature/menuItems',
  getVendorMenuData: apiPrefix + '/roleFeature/vendorMenuItems',
}
export const newYearPopupApiConfig: NewYearPopupApi = {
  showNewYearPopup: apiPrefix + '/Employee/showNewYearPopup',
}

export const userRolesConfigurationApiConfig: UserRolesConfigurationApi = {
  getUserRoles: apiPrefix + '/roleFeature/roles',
  isUserRoleExists: apiPrefix + '/roleFeature/isRoleExits',
  createUserRole: apiPrefix + '/roleFeature/role',
  deleteUserRole: apiPrefix + '/roleFeature/deleterole',
  getSubFeatures: apiPrefix + '/roleFeature/SubFeatures',
  featuresUnderRole: apiPrefix + '/roleFeature/features_UnderRole',
  featuresUnderEmployee: apiPrefix + '/roleFeature/features_UnderEmployee',
  featuresUnderVendor: apiPrefix + '/roleFeature/features_UnderVendor',
  assignPermission: apiPrefix + '/roleFeature/assignPermission',
  assignEmployeePermission: apiPrefix + '/roleFeature/assignEmployeePermission',
}

export const categoriesApiConfig: CategoryApi = {
  getAllCategories: apiPrefix + '/jobapplicant/getAllCategories',
  addCategory: apiPrefix + '/jobapplicant/addCategory',
  deleteCategory: apiPrefix + '/jobapplicant/deleteCategory',
}
export const personalInfoApiConfig: PersonalInfoApi = {
  getFamilyDetails: apiPrefix + '/Employee/familyInformation',
  getVisaDetails: apiPrefix + '/Employee/getEmployeeVisaDetailsList',
  getCountryDetails: apiPrefix + '/Employee/getCountryLookUps',
  getVisaTypeDetails: apiPrefix + '/Employee/getCountryChangeList',
  addNewVisaMember: apiPrefix + '/Employee/saveVisaDetails',
  getFamilyInformation: apiPrefix + '/Employee/getFamilyInformation',
  updateFamilyInformation: apiPrefix + '/Employee/updateFamilyInformation',
  addNewFamilyMember: apiPrefix + '/Employee/saveFamilyInformation',
  getVisaInformation: apiPrefix + '/Employee/getVisaDetails',
  updateVisaInformation: apiPrefix + '/Employee/updateVisaDetailsToEmployee',
  deleteFamilyMember: apiPrefix + '/Employee/deleteFamilymember',
  deleteVisaDetail: apiPrefix + '/Employee/deleteVisaDetail',
  fileUploadVisaImage: apiPrefix + '/fileUpload/uploadVisaImage',
  fileUploadPassportImage: apiPrefix + '/fileUpload/uploadPassPortFrontImage',
  getEmpCountries: apiPrefix + '/jobapplicant/getEmpCountries',
}

export const skillsApiConfig: SkillApi = {
  getSkillListForCategory: apiPrefix + '/jobapplicant/getCategorySkill',
  addNewSkillForCategory:
    apiPrefix + '/jobapplicant/addSkillToSpecificCategory',
  deleteSkillForCategory: apiPrefix + '/jobapplicant/deleteSkill',
}

export const employeeSkillsApiConfig: EmployeeSkillApi = {
  getEmployeeSkills: apiPrefix + '/jobapplicant/getEmployeeskillList',
  addEmployeeSkill: apiPrefix + '/jobapplicant/addSkillToEmployee',
  getEmployeeSkillInformation: apiPrefix + '/jobapplicant/editSkill',
  updateEmployeeSkillInformation:
    apiPrefix + '/jobapplicant/updateEmployeeSkill',
  deleteEmployeeSkill: apiPrefix + '/jobapplicant/deleteEmployeeSkill',
  getEmployeeSkillsById: apiPrefix + '/jobapplicant/getEmployeeskills',
}

export const employeeQualificationCategoryApiConfig: EmployeeQualificationCategoryApi =
  {
    getQualificationCategories:
      apiPrefix + '/Employee/getQualiactionCategoryList',
    createQualificationCategory: apiPrefix + '/Employee/saveQualiCategory',
    deleteQualificationCategory: apiPrefix + '/Employee/deleteQualiCategory',
  }

export const employeeGeneralInformationApi: EmployeeGeneralInformationApi = {
  getLoggedInEmployeeData: apiPrefix + '/jobapplicant/loggedInEmployeeData',
}

export const employeeGeneralInformationApiConfig: EmployeeGeneralInformationApi =
  {
    getLoggedInEmployeeData: apiPrefix + '/jobapplicant/loggedInEmployee',
    loggedInEmployeeData: apiPrefix + '/jobapplicant/loggedInEmployeeData',
    getEmployeeBasicInfo:
      apiPrefix + '/jobapplicant/getEmployeeBasicInfoDetails',
  }

export const qualificationsApiConfig: EmployeeQualificationsApi = {
  getEmployeeQualifications: apiPrefix + '/Employee/getEmployeeQualification',
  addEmployeeQualifications: apiPrefix + '/Employee/saveNewQualification',
  getPostGraduationAndGraduationLookUp:
    apiPrefix + '/Employee/multipleSelection',
  updateEmployeeQualifications: apiPrefix + '/Employee/updateQualification',
}

export const profileHistoryConfig: ProfileHistoryApi = {
  getprofileHistory: apiPrefix + '/Employee/getEmployeeProfileHistory',
}
export const profileRecruitmentHistoryApiConfig: ProfileRecruitmentHistoryApi =
  {
    getEmployeeHistory: apiPrefix + '/Employee/getEmployeeHistory',
  }
export const employeeCertificationsApiConfig: EmployeeCertificationsApi = {
  getEmployeeCertificates: apiPrefix + '/Employee/certification/',
  getTechnologies: apiPrefix + '/jobapplicant/getAllTechnology',
  getCertificateByTechnology:
    apiPrefix + '/EmployeeSkill/getCertificateByTechnology',
  createEmployeeCertification: apiPrefix + '/Employee/certification',
  getEmployeeCertificate: apiPrefix + '/Employee/getCertification',
  updateEmployeeCertificate: apiPrefix + '/Employee/certification',
  deleteEmployeeCertificate: apiPrefix + '/Employee/certification',
  getEmployeeCertificateById: apiPrefix + '/Employee/employeeCertification',
}

export const basicInfoApiConfig: BasicInfoApi = {
  defaultPicByGender: apiPrefix + '/jobapplicant/defaultPic',
  updateEmployeeDetails: apiPrefix + '/jobapplicant/updateEmployeeDetails',
  uploadEmployeeCV: apiPrefix + '/fileUpload/uploadRBTResume',
  uploadEmployeeImage: apiPrefix + '/fileUpload/uploadImage',
  downloadEmployeeCV: apiPrefix + '/jobapplicant/downloadRBTCv',
  downloadSampleCV: apiPrefix + '/jobapplicant/downloadCVFormateFile',
}

export const employeeListConfig: EmployeeListApi = {
  getEmployeeList: apiPrefix + '/jobapplicant/EmployeesIndexData',
  exportEmployeeData: apiPrefix + '/jobapplicant/exportEmployeeData',
  updateHierarchyReportingManager:
    apiPrefix + '/supportManagement/updateHierarchyReportingManager',
}

export const employeeDesignationListApiConfig: EmployeeDesignationListApi = {
  getEmployeeDepartments: apiPrefix + '/assetManagement/getEmpDepartments',
  getEmployeeDesignations: apiPrefix + '/kra/designation',
  addEmployeeDesignation: apiPrefix + '/jobapplicant/addDesignation',
  deleteEmployeeDesignation: apiPrefix + '/jobapplicant/deleteDesignation',
  getAllEmployeeDesignation: apiPrefix + '/jobapplicant/getAllDesignations',
}

export const shiftConfigurationApiConfig: ShiftConfigurationApi = {
  getAllShifts: apiPrefix + '/jobapplicant/getAllShifting',
  addTimeSlot: apiPrefix + '/jobapplicant/addTimeSlot',
  updateShiftDetail: apiPrefix + '/jobapplicant/updateShiftDetail',
  deleteShiftDetail: apiPrefix + '/jobapplicant/deleteShiftDetail',
}

export const employeeReporteesApiConfig: EmployeeReporteesApi = {
  getEmployeeReportees: apiPrefix + '/jobapplicant/getReportiesForManager',
  // getEmployeeReportees: apiPrefix + '/jobapplicant/getReportiesUnderManager', // old api or a newly implemnted api that has been forgotten and no use anymore. This api will always return all reportees including hierarchy.
  getEmployeeReporteesKRAs: apiPrefix + '/kra/kraForIndividual',
  getEmployeeReporteesKPIs: apiPrefix + '/kra/kpisForIndividualKra',
  exportReporteeList: apiPrefix + '/Employee/exportReporteeList',
}

export const certificateListApiConfig: CertificateListApi = {
  getAllEmployeeCertificates:
    apiPrefix + '/EmployeeSkill/getAllEmployeecertificates',
  exportCertificateList: apiPrefix + '/EmployeeSkill/exportCertificatesList',
}

export const employeeAssetsApiConfig: EmployeeAssetsApi = {
  getEmployeeAssets: apiPrefix + '/Employee/getEmployeeAssets',
}

export const certificateTypeApiConfig: CertificateTypeApi = {
  getCertificateTypes: apiPrefix + '/EmployeeSkill/getCertificateTypeList',
  addCertificateType: apiPrefix + '/EmployeeSkill/addCertificateType',
  deleteCertificateType: apiPrefix + '/EmployeeSkill/deleteCertificateType',
  checkIsCertificateTypeExists:
    apiPrefix + '/EmployeeSkill/checkForDuplicateCertificate',
  getCertificateType: apiPrefix + '/EmployeeSkill/editCertificateType',
  updateCertificateType: apiPrefix + '/EmployeeSkill/updateCertificatetype',
}

export const employeeReviewsApiConfig: EmployeeReviewsApi = {
  getEmployeeReviews: apiPrefix + '/jobapplicant/getLoggedInEmployeeReviews',
}

export const employeeReportApiConfig: EmployeeReportApi = {
  getEmployeeReports: apiPrefix + '/jobapplicant/getSelectedTypeEmployeeData',
  getCountries: apiPrefix + '/jobapplicant/getEmpCountries',
  exportEmployeeReportsData:
    apiPrefix + '/jobapplicant/exportSelectedemployeedata',
}

export const employeeDesignationReportApiConfig: EmployeeDesignationReportApi =
  {
    getAllDesignations: apiPrefix + '/jobapplicant/getAllDesignations',
    getEmployeeCategoryData: apiPrefix + '/jobapplicant/EmployeesCategoryData',
    exportEmployeeCategoryData:
      apiPrefix + '/jobapplicant/exportEmployeeCategoryData',
  }

export const visaListApiConfig: VisaListApi = {
  getVisaList: apiPrefix + '/EmployeeSkill/getAllVisaDetails',
  getCountries: apiPrefix + '/EmployeeSkill/getCountries',
  getVisaTypes: apiPrefix + '/Employee/getCountryChangeList',
  exportVisaList: apiPrefix + '/EmployeeSkill/exportEmployeeVisaList',
}

export const employeeProjectsApiConfig: EmployeeProjectsApi = {
  getProjectsClients: apiPrefix + '/project-mgmt/getClients',
  getEmployeeProjects: apiPrefix + '/project-mgmt/getEmployeeProjectslist',
  getProjectDetails: apiPrefix + '/allocation-mgmt/directoryProjects',
}

export const employeeHandbook: EmployeeHandbook = {
  getHandbooks: apiPrefix + '/handbookItem/getHandbookNamesCountryWise',
  getPublishedPolicy: apiPrefix + '/handbookItem/getPublishedPolicy',
  getLoggedinEmployeeHandbookData:
    apiPrefix + '/handbookItem/getLoggedinEmployeeHandbookData',
  addPolicyStatus: apiPrefix + '/handbookItem/addPolicyStatus',
  getEmployeeAcceptedPolicies:
    apiPrefix + '/handbookItem/getEmployeeAcceptedPolicys',
  saveEmployeePolicy: apiPrefix + '/handbookItem/saveEmployeePolicy',
}

export const dispHandbook: DisplayHandbook = {
  dispHandbook: apiPrefix + '/handbookItem/get',
}

export const employeeAttendanceReportApiConfig: EmployeeAttendanceReportApi = {
  getEmployeeAttendance: apiPrefix + '/biometric/bioAdminManager/attendance',
  exportAttendance: apiPrefix + '/biometric/exportAttendance',
  exportBiometricAttendance: apiPrefix + '/biometric/exportAttendance2',
  searchAttendance: apiPrefix + '/biometric/bioAdminManager/searchAttendance',
  exportLateComingsReport: apiPrefix + '/biometric/exportLateComingsReport',
}

export const shortFallReportApiConfig: ShortFAllApi = {
  getShortFallList:
    apiPrefix + '/timeInOffice/getEmployeeTimeDuriationInOffice',
  exportShortFallList:
    apiPrefix + '/timeInOffice/exportAttendanceDuriationReport',
}

export const userApiConfig: UserAccessToFeaturesApi = {
  getUserAccessToFeatures: apiPrefix + '/roleFeature/user',
  getUserAccessToFeaturesForVendor: apiPrefix + '/roleFeature/vendor',
}

export const employeeHandbookSettingsApiConfig: EmployeeHandbookSettingsApi = {
  getEmployeeHandbooks: apiPrefix + '/handbookItem/getAll',
  getMessageDescription: apiPrefix + '/handbookItem/getDiscription',
  deleteEmployeeHandbook: apiPrefix + '/handbookItem/delete',
  addNewHandbook: apiPrefix + '/handbookItem/add',
  addHandBookDiscription: apiPrefix + '/handbookItem/addHandBookDiscription',
  getEmployeeCountries: apiPrefix + '/jobapplicant/getEmpCountries',
  getTotalHandbookList: apiPrefix + '/handbookItem/getTotalList',
  getSelectedCountries: apiPrefix + '/handbookItem/getSelectedCountries',
  updateEmployeeHandbook: apiPrefix + '/handbookItem/updateHandbookItem',
  getPublishedPolicy: apiPrefix + '/handbookItem/getPublishedPolicy',
  getVersionPolicy: apiPrefix + '/handbookItem/getVersion',
  getHandbookPolicyReport: apiPrefix + '/handbookItem/getHandbookPolicyReport',
  exportHandbookPolicyReport:
    apiPrefix + '/handbookItem/exportHandbookPolicyReport',
}

export const timeInOfficeReportApiConfig: TimeInOfficeReportApi = {
  getTimeInOfficeEmployeeReport:
    apiPrefix + '/timeInOffice/getTimeInOfficeEmployeeReport',
  getTimeInOfficeManagerReport:
    apiPrefix + '/timeInOffice/getTimeInOfficeManagerReport',
  exportAttendanceReport: apiPrefix + '/timeInOffice/exportAttendanceReport',
  searchTimeInOffice: apiPrefix + '/timeInOffice/searchTimeInOffice',
}
export const vpnAttendanceApiConfig: VpnAttendanceApi = {
  readVPNExcelFile: apiPrefix + '/biometric/readVPNExcelFile',
  getVPNAttendnace: apiPrefix + '/biometric/getVPNAttendence',
}

export const employeeLeaveSettingsApiConfig: EmployeeLeaveSettingsApi = {
  saveLeaveCalendarSettings:
    apiPrefix + '/leaveSetup/bioAdmin/leaveCalendarSettings',
  getLeaveCategories: apiPrefix + '/leaveSetup/leaveCategoriesForAdmin',
  getLeaveCalenderSettings:
    apiPrefix + '/leaveSetup/bioAdminManager/leaveCalendarSettings',
  deleteLeaveCategory: apiPrefix + '/leaveSetup/bioAdmin/leaveCategory',
  addUpdateLeaveCategory: apiPrefix + '/leaveSetup/bioAdmin/leaveCategory',
  updateLeaveCalendarSettings:
    apiPrefix + '/leaveSetup/bioAdmin/updateLeaveCalendarSettings',
}

export const addNewEmployeeAPiConfig: AddNewEmployeeAPi = {
  getEmployeeDepartments: apiPrefix + '/assetManagement/getEmpDepartments',
  getEmpCountries: apiPrefix + '/jobapplicant/getEmpCountries',
  getAllHrData: apiPrefix + '/jobapplicant/getAllHrData',
  getAllReportingManagersData:
    apiPrefix + '/jobapplicant/getAllReportingManagersData',
  addNewEmployee: apiPrefix + '/jobapplicant/jobAdmin/addNewEmployee',
  editEmployee: apiPrefix + '/jobapplicant/jobAdmin/editEmployee',
  getAllemploymentType: apiPrefix + '/jobapplicant/getEmploymentType',
  getAllJobType: apiPrefix + '/jobapplicant/getJobType',
  getCheckIfUserExist: apiPrefix + '/Employee/isemployeeUsernameexist',
  getVendorDetails: apiPrefix + '/jobapplicant/getVendorDetails',
}

export const hiveActivityReportApiConfig: HiveActivityReportApi = {
  getEmployeeHiveActivityReport:
    apiPrefix + '/timeActivity/employeeHiveReports',
  getManagerHiveActivityReport: apiPrefix + '/timeActivity/managerHiveReports',
  getSearchHiveTime: apiPrefix + '/timeActivity/searchHiveTime',
  exportHiveReport: apiPrefix + '/timeActivity/exportHiveReport',
  employeeDayHiveSheet: apiPrefix + '/timeActivity/employeeDayHiveSheet',
}

export const employeeMailConfigurationApiConfig: EmployeeMailConfigurationApi =
  {
    getMailTemplates: apiPrefix + '/mailTemplates/getMailTemplates',
    getMailTemplateTypes: apiPrefix + '/mailTemplates/getMailTemplateTypes',
    exportMailTemplatesList: apiPrefix + '/mailTemplates/exportMailTemplates',
    updateMailTemplate: apiPrefix + '/mailTemplates/updateMailTemplate',
    deleteMailTemplate: apiPrefix + '/mailTemplates/deleteMailTemplate',
  }

export const addNewTemplateApiConfig: AddNewTemplateApi = {
  getAssetTypes: apiPrefix + '/assetManagement/getAllLookUps',
  addNewMailTemplate: apiPrefix + '/mailTemplates/addMailTemplate',
}

export const applyLeaveAPiConfig: ApplyLeaveApi = {
  getLeaveType: apiPrefix + '/leaveSetup/leaveCategories',
  applyLeave: apiPrefix + '/leave/apply',
}

export const scheduledInterviewsApiConfig: ScheduledInterviewsApi = {
  searchScheduledCandidatesForEmployee:
    apiPrefix + '/jobapplicant/searchScheduledCandidatesForEmployee',
  searchScheduledCandidates:
    apiPrefix + '/jobapplicant/searchScheduledCandidates',
  downloadScheduleCandidates:
    apiPrefix + '/jobapplicant/downloadScheduleCandidates',
}

export const addNewMailTemplateTypeAPiConfig: AddNewMailTemplateTypeApi = {
  getMailTemplateTypes: apiPrefix + '/mailTemplates/getMailTemplateTypes',
  addNewMailTemplateType: apiPrefix + '/mailTemplates/addMailTemplateType',
  updateMailTemplateType: apiPrefix + '/mailTemplates/updateMailTemplateType',
  deleteMailTemplateType: apiPrefix + '/mailTemplates/deleteMailTemplateType',
}

export const myAttendanceApiConfig: MyAttendanceApi = {
  getMyAttendance: apiPrefix + '/biometric/myAttendence',
  getFutureWFHAppliedDates: apiPrefix + '/biometric/getFutureWFHAppliedDates',
}

export const leaveReportsApiConfig: LeaveReportsApi = {
  getLeaveSummaries: apiPrefix + '/leaveSetup/bioAdmin/leaveSummaries',
  searchLeaveSummaries: apiPrefix + '/leaveSetup/searchLeaveSummaries',
  creditedYears: apiPrefix + '/leaveSetup/creditedYears',
  financialYear: apiPrefix + '/leaveSetup/financialYear',
  downloadLeaveReportList: apiPrefix + '/leaveSetup/exportLeaveReport',
}
export const allocateEmployeeApiConfig: AllocateEmployeeApi = {
  getAllEmployeeProfiles:
    apiPrefix + '/jobapplicant/getAllProfileEmployeesData?searchStr',
  getAllProjectSearch: apiPrefix + '/allocation-mgmt/getAllProjectSearch',
  allocateNewEmployee: apiPrefix + '/allocation-mgmt/allocation',
}

export const ticketReportApiConfig: TicketReportApi = {
  getDepartmentNameList: apiPrefix + '/supportManagement/getDepartmentNameList',
  departmentCategoryList:
    apiPrefix + '/supportManagement/departmentCategoryList',
  getTicketsReport: apiPrefix + '/supportManagement/getTicketsReport',
  getTicketsDetails: apiPrefix + '/supportManagement/getTicketsDetails',
  exportTicketReports: apiPrefix + '/supportManagement/exportReportList',
}

export const projectManagementConfig: ProjectManagementApi = {
  addProject: apiPrefix + '/project-mgmt/project',
  updateProject: apiPrefix + '/project-mgmt/project',
  getProject: apiPrefix + '/project-mgmt/project',
  getAllPlatforms: apiPrefix + '/project-mgmt/getAllPlatforms',
  getAllDomains: apiPrefix + '/project-mgmt/getAllDomains',
  getAllManagers: apiPrefix + '/project-mgmt/getAllManagers',
  getActiveProjectReports:
    apiPrefix + '/project-mgmt/activeProjectsForEmployee',
  getSearchAllocationReport: apiPrefix + '/project-mgmt/searchAllocationReport',
  getClientProjects: apiPrefix + '/allocation-mgmt/projects',
  getCloseProject: apiPrefix + '/project-mgmt/closeProject',
  getDeleteProject: apiPrefix + '/project-mgmt/projectDelete',
  postDeallocateProject: apiPrefix + '/project-mgmt/deAllocateProject',
  postUpdateAllocateProject: apiPrefix + '/project-mgmt/updateAllocateProject',
  exportProjectList: apiPrefix + '/project-mgmt/exportProjectList',
  projectsOfClients: apiPrefix + '/project-mgmt/projectsOfClients',
}

export const clientsApiConfig: ClientsApi = {
  getClients: apiPrefix + '/project-mgmt/client',
  getProjectsUnderClient: apiPrefix + '/project-mgmt/projectsUnderClient',
  searchClients: apiPrefix + '/project-mgmt/searchClients',
  deleteClient: apiPrefix + '/project-mgmt/deleteClient',
  editClient: apiPrefix + '/project-mgmt/client',
  updateClient: apiPrefix + '/project-mgmt/updateClient',
  getClientCountries: apiPrefix + '/project-mgmt/country',
  clientOrg: apiPrefix + '/project-mgmt/clientOrg',
}

export const addNewClientApiConfig: AddNewClientApi = {
  getClientCountries: apiPrefix + '/project-mgmt/country',
  addNewClient: apiPrefix + '/project-mgmt/client',
  checkClientOrgExist: apiPrefix + '/project-mgmt/clientOrg',
}

export const clientInformationApiConfig: ClientInformationApi = {
  getClientInformation: apiPrefix + '/project-mgmt/getClientInfo',
}

export const leaveSummaryApiConfig: LeaveSummaryApi = {
  getEmployeeLeaveSummary: apiPrefix + '/leave/leaveSummary',
  getEmployeeLeaveHistory: apiPrefix + '/leave/leaves',
  cancelEmployeeLeave: apiPrefix + '/leave/cancel',
  cancelAfterApproval: apiPrefix + '/leave/cancelAfterApproval',
  checkEmpCountries: apiPrefix + '/leave/checkEmployeeCountries',
}

export const ticketListInformationApiConfig: TicketListInformationApi = {
  getTicketListInformation: apiPrefix + '/supportManagement/searchTicketData',
  exportTicketList: apiPrefix + '/supportManagement/exportRaisedTickets',
  ticketHistoryDetails: apiPrefix + '/supportManagement/getAudit',
  cancelTicket: apiPrefix + '/supportManagement/cancelTicketRequest',
}

export const ticketApprovalsApiConfig: TicketApprovalsApi = {
  getActiveEmployeeList: apiPrefix + '/assetManagement/getActiveEmployeeList',
  getDepartmentNameList: apiPrefix + '/supportManagement/getDepartmentNameList',
  getAllTrackerList: apiPrefix + '/supportManagement/getAllTracker',
  getAllLookups: apiPrefix + '/supportManagement/getAllLookups',
  departmentCategoryList:
    apiPrefix + '/supportManagement/departmentCategoryList',
  subCategoryList: apiPrefix + '/supportManagement/subCategoryList',
  getAllTicketsForApproval:
    apiPrefix + '/supportManagement/getAllTicketsForApproval',
  exportTicketApprovalList:
    apiPrefix + '/supportManagement/exportTicketApprovalList',
  rejectManagerTicket: apiPrefix + '/supportManagement/rejectManagerTicket',
  downloadFile: apiPrefix + '/supportManagement/downloadFile',
}

export const createNewTicketApiConfig: RaiseNewTicketApi = {
  createNewTicket: apiPrefix + '/supportManagement/createTickets',
  uploadSupportTicketsDocument:
    apiPrefix + '/fileUpload/uploadSupportTicketsDocuments',
  getDepartmentListForRaise:
    apiPrefix + '/supportManagement/getDepartmentListForRaise',
}

export const dashboardApiConfig: DashboardApi = {
  getAllJobVacancies: apiPrefix + '/jobvacancy/getAllJobVacancies',
  getUpcomingBirthdayAnniversaries:
    apiPrefix + '/Employee/upcomingBirthdayAnniversaries',
  getAllEmployeesBirthdayList:
    apiPrefix + '/Employee/upcomingBirthdayAnniversaries',
  getUpcomingServiceAnniversaries:
    apiPrefix + '/Employee/upcomingServiceAnniversaries',
  getAllServiceAnniversaries:
    apiPrefix + '/Employee/upcomingServiceAnniversaries',
  getUpcomingHolidays: apiPrefix + '/Employee/onlyUpcomingHolidays',
  getAllUpcomingHolidaysList: apiPrefix + '/Employee/upcomingHolidays',
  addHoliday: apiPrefix + '/Employee/saveHoliday',
  getFinancialYear: apiPrefix + '/leaveSetup/financialYear',
  getEmployeeTimeInOffice: apiPrefix + '/timeInOffice/weeklyTimeInOfficeReport',
  getUpcomingTrainings: apiPrefix + '/meetingRequest/getTrainingsForDashBoard',
  getUpcomingEvents: apiPrefix + '/meetingRequest/getEventsForDashBoard',
  getEmployeesUnderProbationPeriod: apiPrefix + '/Employee/provisionPeriod',
  getAllAchievements: apiPrefix + '/achievement/getAllAchievementList',
  deleteHoliday: apiPrefix + '/Employee/deleteHoliday',
  getHolidayInformation: apiPrefix + '/Employee/holiday',
  updateHoliday: apiPrefix + '/Employee/editHoliday',
  searchEmployee: apiPrefix + '/jobapplicant/getAllProfileEmployeesData',
  getLeaveSummary: apiPrefix + '/leave/leaveSummaryDashboard',
  // Added missing slash after removing trailing slash from apiPrefix
  imageFix: apiPrefix + '/profilepics/1857-Thumb.jpg',
  getAllPendingInterviewComments:
    apiPrefix + '/jobapplicant/getAllPendingInterviewComments',
  getEmployeesUnderOnContract:
    apiPrefix + '/jobapplicant/getUpcomingOnContractEmployees',
}

export const addLocationListApiConfig: AddLocationListApi = {
  getAllMeetingLocations: apiPrefix + '/meetingRequest/getAllMeetingLocations',
  addLocation: apiPrefix + '/meetingRequest/addLocation',
  deleteLocation: apiPrefix + '/meetingRequest/deleteLocation',
}

export const updateTicketApiConfig: UpdateTicketApi = {
  getTicket: apiPrefix + '/supportManagement/getTicket',
  getActiveEmployeeList: apiPrefix + '/assetManagement/getActiveEmployeeList',
  getAudit: apiPrefix + '/supportManagement/getAudit',
  uploadSupportTicketDocuments:
    apiPrefix + '/fileUpload/uploadSupportTicketsDocuments',
  updateIndividualTickets:
    apiPrefix + '/supportManagement/editIndividualTickets',
  approveTicketByManager:
    apiPrefix + '/supportManagement/approveByManagerTicket',
}

export const bookingListApiConfig: BookingListApi = {
  getRoomsOfLocation: apiPrefix + '/meetingRequest/getRoomsOfLocation',
  getAllMeetingLocations: apiPrefix + '/meetingRequest/getAllMeetingLocations',
  getBookingsForSelection:
    apiPrefix + '/meetingRequest/getBookingsForSelection',
  cancelRoomBooking: apiPrefix + '/meetingRequest/changeMeetingStatus/',
  editMeeting: apiPrefix + '/meetingRequest/editmeeting',
  confirmUpdateMeetingRequest:
    apiPrefix + '/meetingRequest/confirmupdateMeetingRequest',
  uniqueAttendee:
    apiPrefix + '/meetingRequest/uniqueAttendeeuniqueAttendeeWithId',
  changeMeetingStatus: apiPrefix + '/meetingRequest/changeMeetingStatus',
}

export const eventTypeListApiConfig: EventTypeListApi = {
  getAllEventTypes: apiPrefix + '/meetingRequest/getAllEventTypes',
  addEventType: apiPrefix + '/meetingRequest/addEventType',
  deleteEventType: apiPrefix + '/meetingRequest/deleteEventType',
  updateEventType: apiPrefix + '/meetingRequest/updateEventType',
}

export const newEventApiConfig: NewEventApi = {
  getLoggedEmployeeName: apiPrefix + '/meetingRequest/getLoggedEmployeeName',
  getRoomsOfLocation: apiPrefix + '/meetingRequest/getRoomsOfLocation',
  getAllProfileEmployeesData:
    apiPrefix + '/jobapplicant/getAllProfileEmployeesData',
  getAllAttendees: apiPrefix + '/meetingRequest/getAllAttendies',
  uniqueAttendee: apiPrefix + '/meetingRequest/uniqueAttendee',
  timeChecking: apiPrefix + '/meetingRequest/timechecking',
  getAllBookedDetailsForEvent:
    apiPrefix + '/meetingRequest/getAllBookedDetailsForEvent',
  addNewEvent: apiPrefix + '/meetingRequest/addNewEvent',
}

export const employeeAllocationApiConfig: EmployeeAllocationApi = {
  getEmployeeAllocationReport: apiPrefix + '/project-mgmt/searchByEmployeeName',
  projectUnderEmployees: apiPrefix + '/project-mgmt/projectUnderEmployees/',
  updateEmployeeAllocateProject:
    apiPrefix + '/project-mgmt/updateEmployeeAllocateProject',
  downloadEmployeeAllocationList: apiPrefix + '/project-mgmt/exportFile',
  downloadExportEmployeeAllocationList:
    apiPrefix + '/project-mgmt/exportEmployeeAllocation',
}

export const eventListApiConfig: EventListApi = {
  getAllEvents: apiPrefix + '/meetingRequest/getAllEvents',
  cancelEvent: apiPrefix + '/meetingRequest/cancelEvent',
  getFeedbackFormList: apiPrefix + '/meetingRequest/getFeedbackFormList',
  downloadFeedbackForm: apiPrefix + '/meetingRequest/downloadFeedbackForm',
  uploadFeedbackForm:
    apiPrefix + '/fileUpload/uploadMeetingRequestFeedbackForm',
  editEvent: apiPrefix + '/meetingRequest/editmeeting',
  updateEvent: apiPrefix + '/meetingRequest/updateEvent',
}

export const addTrackerApiConfig: AddTrackerApi = {
  addNewTracker: apiPrefix + '/supportManagement/addTracker',
  deleteTracker: apiPrefix + '/supportManagement/deleteTracker',
}

export const appraisalConfigurationsApiConfig: AppraisalConfigurationsApi = {
  cycle: apiPrefix + '/appraisal/cycle',
  editAppraisalCycle: apiPrefix + '/appraisal/getCycle',
  updateAppraisalCycle: apiPrefix + '/appraisal/updateCycle',
  validateCycle: apiPrefix + '/appraisal/validateCycle',
}
export const addConfigurationsApiConfig: AddConfigurationsApi = {
  addAppraisalCycle: apiPrefix + '/appraisal/cycle',
}

export const roomListApiConfig: RoomListApi = {
  getAllMeetingRooms: apiPrefix + '/meetingRequest/getAllMeetingRooms',
  addRoom: apiPrefix + '/meetingRequest/addRoom',
  deleteRoom: apiPrefix + '/meetingRequest/deleteRoom',
  updateRoom: apiPrefix + '/meetingRequest/updateRoom',
  getRoomsOfLocation: apiPrefix + '/meetingRequest/getRoomsOfLocation',
  getAllMeetingLocations: apiPrefix + '/meetingRequest/getAllMeetingLocations',
}

export const assignTemplateApiConfig: AssignTemplateApi = {
  getEmpDepartments: apiPrefix + '/assetManagement/getEmpDepartments',
  designationDeptId: apiPrefix + '/kra/designation',
  alreadyExistNewCycleId: apiPrefix + '/appraisal/isAlreadyExist',
  getDesignationWiseKRAs: apiPrefix + '/kra/getDesignationWiseKRAs',
  getDesignationNumber: apiPrefix + '/appraisal/underKras',
  copyTheCycleData: apiPrefix + '/appraisal/copyTheCycleData',
  searchKRAData: apiPrefix + '/kra/searchKRAData',
  kpisForIndividualKra: apiPrefix + '/kra/kpisForIndividualKra',
  designingMaping: apiPrefix + '/kra/designingmaping',
  searchKRANumber: apiPrefix + '/appraisal/underKras',
}

export const ticketConfigurationApiConfig: TicketConfigurationApi = {
  getDepartments: apiPrefix + '/supportManagement/getDepartmentNameList',
  getCategories: apiPrefix + '/supportManagement/departmentCategoryList',
  getSubCategories: apiPrefix + '/supportManagement/subCategoryList',
  getSubCategoryList: apiPrefix + '/supportManagement/getSearchSubCategoryList',
  deleteSubCategory: apiPrefix + '/supportManagement/deleteSubCategory',
  ticketHistory: apiPrefix + '/supportManagement/getAudit',
  addSubCategory: apiPrefix + '/supportManagement/addSubCategory',
  getAllCategory: apiPrefix + '/supportManagement/getAllCategoryList',
  deleteCategory: apiPrefix + '/supportManagement/deleteCategory',
  addCategory: apiPrefix + '/supportManagement/addCategory',
  updateCategory: apiPrefix + '/supportManagement/updateCategory',
  updateSubCategory: apiPrefix + '/supportManagement/updateSubCategory',
}

export const submitResignationApiConfig: SubmitResignationApi = {
  getSeparationForm: apiPrefix + '/separationController/getSeparationForm',
  submitResignation: apiPrefix + '/separationController/SubmitResignation',
  getEmployeeResg: apiPrefix + '/separationController/getEmployeeResg',
  revokeResignation: apiPrefix + '/separationController/revokeResignation',
}

export const leaveApprovalsApiConfig: LeaveApprovalsApi = {
  getEmployees: apiPrefix + '/managerAppraisalController/getEmployees',
  getEmployeeLeaves: apiPrefix + '/leave/bioAdminManager/employeeLeaves',
  getSearchEmployees: apiPrefix + '/leave/bioAdminManager/searchEmployees',
  checkProjectManagerExits: apiPrefix + '/leave/checkProjectManagerExits',
  leaveApprove: apiPrefix + '/leave/bioAdminManager/approve',
  leaveReject: apiPrefix + '/leave/bioAdminManager/reject',
  datePeriod: apiPrefix + '/leave/datePeiod',
}

export const payrollManagementApiConfig: PayrollManagementApi = {
  financeDetails: apiPrefix + '/Employee/financeDetails',
  getCurrentPayslip: apiPrefix + '/payslip/payrolladmin/getCurrentPayslip',
  downloadExcelFile: apiPrefix + '/payslip/payrolladmin/downloadExcelFile',
  searchEmployee: apiPrefix + '/payslip/payrolladmin/searchEmployee',
  deletePayslip: apiPrefix + '/payslip/payrolladmin/deletePayslip',
  updatePayslip: apiPrefix + '/payslip/payrolladmin/updatePayslip',
  deleteCheckedPayslips:
    apiPrefix + '/payslip/payrolladmin/deleteCheckedPayslips',
  readExcelFile: apiPrefix + '/payslip/payrolladmin/readExcelFile',
  saveExcelFile: apiPrefix + '/payslip/payrolladmin/saveExcelFile',
  clearDirectory: apiPrefix + '/payslip/payrolladmin/clearDirectory',
}

export const itDeclarationFormApiConfig: ITDeclarationFormApi = {
  getEmployeeInfo: apiPrefix + '/itDeclaration/getEmployee',
  getSectionsHavingInvests:
    apiPrefix + '/itDeclaration/getSectionsHavingInvests',
  getInvestsBySectionId: apiPrefix + '/itDeclaration/getInvestsBySecId',
  addITDeclarationForm: apiPrefix + '/itDeclaration/addITDeclarationForm',
  isITDeclarationFormExist: apiPrefix + '/itDeclaration/isItDeclareExist',
  uploadITDocuments: apiPrefix + '/itDeclaration/uploadItDeclareDocuments',
}

export const paySlipsApiConfig: PaySlipsApi = {
  getEmployeePayslipsForSelectedYear:
    apiPrefix + '/payslip/getEmployeePayslipsForSelectedYear',
  generatePayslipAndDownloadPayslip:
    apiPrefix + '/payslip/payrolladmin/generatePayslipAndDownloadPayslip',
  downloadPayslip: apiPrefix + '/payslip/downloadPayslip',
  taxCalculator: apiPrefix + '/payslip/taxCalculator',
}

export const insuranceApiConfig: InsuranceApi = {
  uploadFolder: apiPrefix + '/payslip/uploadFolder',
  getInsuranceDetails: apiPrefix + '/itDeclaration/getHealthInsuranceFiles',
  downloadInsurance: apiPrefix + '/payslip/downloadInsuranceFile',
  saveInsurance: apiPrefix + '/itDeclaration/saveInsuranceEcardsData',
  deleteSingleInsurance: apiPrefix + '/payslip/deleteInsuranceFile',
  deleteMultipleInsurance: apiPrefix + '/payslip/deleteCheckedInsuranceFiles',
  viewInsurance: apiPrefix + '/itDeclaration/getInsuranceDiscription',
}
export const AppraisalCardUploadAPIConfig: AppraisalCardUploadAPI = {
  getAppraisalFiles: apiPrefix + '/itDeclaration/getAppraisalFiles',
  downloadAppraisalFile: apiPrefix + '/itDeclaration/downloadAppraisalFile',
  saveAppraisalFileForYear:
    apiPrefix + '/itDeclaration/saveAppraisalFileForYear',
}

export const panDetailsApiConfig: PanDetailsApi = {
  bankInformation: apiPrefix + '/Employee/bankInformation',
  updateFinanceInformation: apiPrefix + '/Employee/updateFinanceInformation',
  uploadEmployeeFinanceDetails:
    apiPrefix + '/fileUpload/uploadEmployeeFinanceDetails',
  downloadFinanceFile: apiPrefix + '/Employee/downloadFinanceFile',
}

export const bankDetailsApiConfig: BankDetailsApi = {
  getBankNameLookup: apiPrefix + '/Employee/getBankNameLookup',
  saveBankInformation: apiPrefix + '/Employee/saveBankInformation',
  updateBankInformation: apiPrefix + '/Employee/updateBankInformation',
  deleteBankAccount: apiPrefix + '/Employee/deleteBankAccount',
  editBankInformation: apiPrefix + '/Employee/bankInformation',
}
export const resignationListApiConfig: ResignationListApi = {
  resignationList: apiPrefix + '/separationController/resignationList',
  exportResignationList:
    apiPrefix + '/separationController/exportResignationList',
  resignationInitiateCC: apiPrefix + '/separationController/IntitiateCC',
  getSeparationTimeLine: apiPrefix + '/separationController/getSeparation',
  clearanceCertificateComments:
    apiPrefix + '/separationController/clearanceCertificateComments',
  getClearanceDetails: apiPrefix + '/separationController/getClearanceDetails',
  updateCCDetails: apiPrefix + '/separationController/updateCC',
  checkExitFeedBackForm:
    apiPrefix + '/separationController/checkExitFeedBackForm',
  getSeparationChart: apiPrefix + '/separationController/getSeparationChart',
  getEmpDetails: apiPrefix + '/separationController/getEmpDetails',
  saveExitFeedBackForm:
    apiPrefix + '/separationController/saveExitFeedBackForm',
  uploadRelievingLetter: apiPrefix + '/fileUpload/uploadrelievingletter',
  uploadExitFeedBackFile: apiPrefix + '/fileUpload/uploadExitfeedBackFile',
  updateTimeLine: apiPrefix + '/separationController/updateSeparation',
}
export const itDeclarationListApiConfig: ITDeclarationListApi = {
  getCycles: apiPrefix + '/itDeclaration/getCycles',
  getSections: apiPrefix + '/itDeclaration/getSection',
  getITDeclarationForm: apiPrefix + '/itDeclaration/getItDeclarationForm',
  exportITDeclarationList: apiPrefix + '/itDeclaration/exportITDeclarationList',
  addCycle: apiPrefix + '/itDeclaration/addCycle',
  deleteSection: apiPrefix + '/itDeclaration/deleteSection',
  addSection: apiPrefix + '/itDeclaration/addSection',
  updateSection: apiPrefix + '/itDeclaration/editSection',
  getInvestments: apiPrefix + '/itDeclaration/getInvestments',
  addInvestment: apiPrefix + '/itDeclaration/addInvestment',
  deleteInvestment: apiPrefix + '/itDeclaration/deleteInvestment',
  deleteCycle: apiPrefix + '/itDeclaration/deleteCycle',
  isCycleExist: apiPrefix + '/itDeclaration/isCycleExist',
  updateCycle: apiPrefix + '/itDeclaration/editCycle',
  updateInvestment: apiPrefix + '/itDeclaration/updateInvestment',
  isInvestmentExist: apiPrefix + '/itDeclaration/isInvestmentExist',
  isSectionExist: apiPrefix + '/itDeclaration/isSectionExist',
  getEmployeeDetails: apiPrefix + '/itDeclaration/getEmployee',
  isITFormEditable: apiPrefix + '/itDeclaration/isItFormEditable',
  editITForm: apiPrefix + '/itDeclaration/editItForm',
  downloadITFile: apiPrefix + '/itDeclaration/downloadITFile',
}
export const InvestmentCheckListApiConfig: InvestmentCheckListApi = {
  getInvestments: apiPrefix + '/itDeclaration/getInvestsBySecId',
  getSections: apiPrefix + '/itDeclaration/getSection',
}
export const reviewListApiConfig: ReviewListApi = {
  getReviewList: apiPrefix + '/appraisal/getSearchResult',
  getAppraisalCycles: apiPrefix + '/appraisal/cycle',
  getDesignations: apiPrefix + '/kra/designation',
  exportReviewList: apiPrefix + '/appraisal/exportAppraisalList',
  activeCycle: apiPrefix + '/appraisal/activeCycle',
}
export const CommonAchievementsApiConfig: CommonAchievementsApi = {
  getAllAchievementsType: apiPrefix + '/achievement/getAllAchievementType',
}
export const AchieverListApiConfig: AchieverListApi = {
  getAchieverList: apiPrefix + '/achievement/getAllAchievement',
  updateShowOnDashbord: apiPrefix + '/achievement/showOnDashBoard',
  achievementHistoryTimeline: apiPrefix + '/achievement/getAchievementHistory',
  deleteAchievement: apiPrefix + '/achievement/deleteAchievement',
}
export const addProjectCreationRequestApiConfig: AddProjectCreationRequestApi =
  {
    getCheckList: apiPrefix + '/project-mgmt/getCheckList',
    getProjectRequestMailIds:
      apiPrefix + '/project-mgmt/getProjectRequestMailIds',
    addProjectRequest: apiPrefix + '/project-mgmt/projectRequest',
  }
export const projectClosureRequestApiConfig: ProjectClosureRequestApi = {
  getCheckList: apiPrefix + '/project-mgmt/getProjectCheckList',
  getPermissions: apiPrefix + '/project-mgmt/isProjectManager',
  addCheckList: apiPrefix + '/project-mgmt/projectClosureRequest',
  getAllCheckLists: apiPrefix + '/project-mgmt/getProjectClosureList',
  getProjectCheckList: apiPrefix + '/project-mgmt/getProjectClosureRequest',
  updateCheckList: apiPrefix + '/project-mgmt/projectClosureRequest',
  getClosureHistory: apiPrefix + '/project-mgmt/getProjectClosureHistory',
  getUploadFiles: apiPrefix + '/project-mgmt/downloadProjectClosureFile',
  uploadFiles: apiPrefix + '/project-mgmt/uploadProjectClosureFile',
  getIsClosureEnable: apiPrefix + '/project-mgmt/isClosureEnable',
}
export const EditProjectCreationRequestApiConfig: EditProjectCreationRequestApi =
  {
    getCheckList: apiPrefix + '/project-mgmt/getCheckList',
    getProjectRequestMailIds:
      apiPrefix + '/project-mgmt/getProjectRequestMailIds',
    editProjectRequest: apiPrefix + '/project-mgmt/projectRequest',
  }
export const ProjectCreationRequestApiConfig: ProjectCreationRequestApi = {
  getAllProjectRequestList:
    apiPrefix + '/project-mgmt/getAllProjectRequestList',
  getProjectRequest: apiPrefix + '/project-mgmt/getProjectRequest',
  getAuditForProjectRequest:
    apiPrefix + '/project-mgmt/getAuditForProjectRequest',
  projectRequestMailIds: apiPrefix + '/project-mgmt/projectRequestMailId',
  getApproveProjectRequest: apiPrefix + '/project-mgmt/getProjectRequest',
  updateProjectRequest: apiPrefix + '/project-mgmt/project',
  deleteProjectRequest: apiPrefix + '/project-mgmt/deleteProjectRequest',
  rejectProjectRequest: apiPrefix + '/project-mgmt/rejectProjectRequest',
}
export const AddAchieverApiConfig: AddAchieverApi = {
  addAchievementType: apiPrefix + '/achievement/addAchievementType',
  getAchievementTypeDetails:
    apiPrefix + '/achievement/getAchievementTypeDetails',
  updateAchievementTypeDetails:
    apiPrefix + '/achievement/updateAchievementType',
  deleteAchievementType: apiPrefix + '/achievement/deleteAchievementType',
  getActiveEmployeeList: apiPrefix + '/assetManagement/getActiveEmployeeList',
  addAchievement: apiPrefix + '/achievement/addAchievement',
  getImageData: apiPrefix + '/achievement/getImageData',
}
export const NomineeListApiConfig: NomineeListApi = {
  getAllCycles: apiPrefix + '/nominationController/getallcycles',
  getNominations: apiPrefix + '/nominationController/getNominations',
  getNominationDetails:
    apiPrefix + '/nominationController/getNominationDetails',
  reviewNominee: apiPrefix + '/nominationController/reviewNominee',
  exportNomineeList: apiPrefix + '/nominationController/exportNomineesList',
}
export const AddNomineeApiConfig: AddNomineeApi = {
  nominationFormDetails:
    apiPrefix + '/nominationController/nominationFormDetails',
  addNominee: apiPrefix + '/nominationController/addNominee',
}
export const employeeAccountsApiConfig: EmployeeAccountsApi = {
  financeDetails: apiPrefix + '/Employee/financeDetails',
  exportFinanceList: apiPrefix + '/Employee/exportFinanceList',
}
export const projectViewApiConfig: ProjectDetailsApi = {
  getProjects: apiPrefix + '/allocation-mgmt/projects',
  getProject: apiPrefix + '/project-mgmt/project',
  updateProjectDetails: apiPrefix + '/project-mgmt/updateAllocateProject',
  downloadInitationCheckList:
    apiPrefix + '/project-mgmt/downloadInitationCheckList',
}
export const projectTimeLineApiConfig: ProjectTimeLineApi = {
  getProjectHistory: apiPrefix + '/project-mgmt/getProjectHistory',
}
export const projectChangeRequestApiConfig: ProjectChangeRequestApi = {
  getCRList: apiPrefix + '/project-mgmt/getCRList',
  changeRequest: apiPrefix + '/project-mgmt/changeRequest',
  deleteCR: apiPrefix + '/project-mgmt/deleteCR',
  updateChangeRequest: apiPrefix + '/project-mgmt/updateChangeRequest',
}
export const projectMileStoneApiConfig: ProjectMilestoneApi = {
  mileStonesList: apiPrefix + '/project-mgmt/mileStonesList',
  mileStoneHistory: apiPrefix + '/milestoneaudit/',
  getMilestone: apiPrefix + '/project-mgmt/getMilestone',
  milestoneNewsFeed: apiPrefix + '/projectnewsfeed/milestoneNewsFeed/',
  uploadImage: apiPrefix + '/projectnewsfeed/uploadImage',
  postMileStone: apiPrefix + '/projectnewsfeed/',
  milestoneDelete: apiPrefix + '/project-mgmt/milestoneDelete',
  closeMilestone: apiPrefix + '/project-mgmt/closeMilestone',
  reOpenMilestone: apiPrefix + '/project-mgmt/reOpenRaisedInvoiceMilestone',
  editMilestone: apiPrefix + '/project-mgmt/getMilestone',
  getPeopleForMilestone: apiPrefix + '/allocation-mgmt/getPeopleForMilestone',
  getMilestoneNumber: apiPrefix + '/project-mgmt/getMilestoneNumber',
  getCRListForMilestone: apiPrefix + '/project-mgmt/getCRListForMilestone',
  getWorkDetails: apiPrefix + '/project-mgmt/getWorkDetails',
  mileStones: apiPrefix + '/project-mgmt/mileStones',
  updateMileStone: apiPrefix + '/project-mgmt/updateMileStone',
  mileStonePercentage: apiPrefix + '/project-mgmt/mileStones',
  getRaisedInvoices: apiPrefix + '/project-mgmt/getRaisedInvoices',
}
export const projectInvoicesApiConfig: ProjectInvoiceApi = {
  getClosedMilestonesAndCRs:
    apiPrefix + '/project-mgmt/getClosedMilestonesandCRs',
  getInvoicesOfMilestone: apiPrefix + '/invoice/getInvoicesOfMilestone',
  getInvoiceSummary: apiPrefix + '/invoice/getInvoiceSummary',
  isProformaRefrece: apiPrefix + '/invoice/isProformaRefrece',
  getInvoicePDF: apiPrefix + '/invoice/getInvoicePDF',
  latestInvoiceVersion: apiPrefix + '/invoice/latestInvoiceVersion',
  invoiceTracker: apiPrefix + '/invoice/invoiceTracker',
}
export const projectTailoringApiConfig: ProjectTailoringApi = {
  getProjectTailoringDocument:
    apiPrefix + '/projectTailoring/getProjectTailoringDocument',
  getProjectTailoring: apiPrefix + '/projectTailoring/getProjectTailoring',
  saveProjectTailoringDocumentForManager:
    apiPrefix + '/projectTailoring/saveProjectTailoringDocumentForManager',
  saveProjectTailoringDocument:
    apiPrefix + '/projectTailoring/saveProjectTailoringDocument',
}
export const projectTimeSheetApiConfig: ProjectTimeSheetApi = {
  getProjectTimeSheet: apiPrefix + '/allocation-mgmt/getProjectTimeSheet',
}
export const projectProposalsApiConfig: ProjectProposalApi = {
  projectProposal: apiPrefix + '/project-mgmt/projectProposal',
}
export const projectNotesApiConfig: ProjectNotesApi = {
  projectNotesTimeLine: apiPrefix + '/projectnewsfeed/',
  uploadImage: apiPrefix + '/projectnewsfeed/uploadImage',
}
export const initiateCycleApiConfig: InitiateCycleApi = {
  getActiveCycleData: apiPrefix + '/nominationController/getActiveCycleData',
  getallcycles: apiPrefix + '/nominationController/getallcycles',
  getAllQuestions: apiPrefix + '/nominationController/getAllQuestions',
  initiateCycle: apiPrefix + '/nominationController/initiateCycle',
  deleteQuestion: apiPrefix + '/nominationController/deleteQuestion',
  addQuestion: apiPrefix + '/nominationController/addQuestion',
  addCycle: apiPrefix + '/nominationController/addCycle',
  editCycle: apiPrefix + '/nominationController/editCycle',
  updateCycle: apiPrefix + '/nominationController/updateCycle',
}
export const myKRAsApiConfig: MyKRAsApi = {
  getKRAForIndividualEmployee: apiPrefix + '/kra/kraForIndividual',
  getKPIsForIndividualEmployee: apiPrefix + '/kra/kpisForIndividualKra',
}
export const newBookingApiConfig: NewBookingApi = {
  getLoggedEmployeeName: apiPrefix + '/meetingRequest/getLoggedEmployeeName',
  getAllProfileEmployeesData:
    apiPrefix + '/jobapplicant/getAllProfileEmployeesData',
  getAllProjectSearch: apiPrefix + '/allocation-mgmt/getAllProjectSearch',
  confirmNewMeetingAppointment:
    apiPrefix + '/meetingRequest/confirmNewMeetingAppointment',
  getAllMeetingAppointmentList:
    apiPrefix + '/meetingRequest/getAllMeetingAppointmentList',

  getAllMeetingAppointmentListWhileEdit:
    apiPrefix + '/meetingRequest/getAllMeetingAppointmentListWhileEdit',
}
export const LeadershipEnrollmentFormApiConfig: LeadershipEnrollmentFormApi = {
  employeeDetails: apiPrefix + '/achievement/getEmployeeDetails',
  addLeadership: apiPrefix + '/achievement/addLeadership',
}
export const LeadershipEnrollmentListApiConfig: LeadershipEnrollmentListApi = {
  getLeadershipList: apiPrefix + '/achievement/getLeadershipList',
  leadershipApprove: apiPrefix + '/achievement/leadershipApprove',
  leadershipReject: apiPrefix + '/achievement/leadershipReject',
}
export const KRAApiConfig: KRAApi = {
  getEmpDepartments: apiPrefix + '/assetManagement/getEmpDepartments',
  getDesignation: apiPrefix + '/kra/designation',
  searchKRAData: apiPrefix + '/kra/searchKRAData',
  kpiForIndividualKra: apiPrefix + '/kra/kpisForIndividualKra',
  deleteKRA: apiPrefix + '/kra/',
  deleteKPI: apiPrefix + '/kra/',
  designationKRAPercentage: apiPrefix + '/kra/designationKraPercentage',
  checkIfNewKRADuplicate: apiPrefix + '/kra/',
  addNewKRA: apiPrefix + '/kra/',
  editThisKra: apiPrefix + '/kra/',
  updateKRA: apiPrefix + '/kra/',
  getFrequency: apiPrefix + '/kra/frequencyList',
  addKPI: apiPrefix + '/kra/',
  updateKPI: apiPrefix + '/kra/updateKpi',
  checkIfNewKpiDuplicate: apiPrefix + '/kra/',
}
export const myReviewApiConfig: MyReviewApi = {
  getEmployeePerformanceReview: apiPrefix + '/handbookItem/get',
  getAppraisalForm: apiPrefix + '/appraisal/AppraisalForm',
  getExistingAppraisalForm: apiPrefix + '/appraisal/existingAppraisalForm',
  getPerformanceRatings: apiPrefix + '/observation-mgnt/getPerformanceRatings',
  employeeAppraisalForm: apiPrefix + '/appraisal/EmployeeAppraisalForm',
  employeeAppraisalFormForRating:
    apiPrefix + '/appraisal/employeeAppraisalFormForRating',
  saveReviewComments: apiPrefix + '/appraisal/saveReviewComments',
  getReviewComments: apiPrefix + '/appraisal/getReviewComments',
  appraisalConfirmation: apiPrefix + '/appraisal/appraisalConfirmation',
  closeAppraisalForm: apiPrefix + '/appraisal/closeAppraisalForm',
  changedKPISRating: apiPrefix + '/appraisal/changedKPISRating',
}
export const PipListApiConfig: PIPListApi = {
  getAllPIPList: apiPrefix + '/PIPManagement/getAllPIPList',
  exportPIPList: apiPrefix + '/PIPManagement/exportPIPList',
  getPerformanceRatings: apiPrefix + '/observation-mgnt/getPerformanceRatings',
  activeEmployee: apiPrefix + '/observation-mgnt/activeEmployee/',
  addPIP: apiPrefix + '/PIPManagement/addPIP',
  viewPipDetails: apiPrefix + '/PIPManagement/viewPipDetails',
  getPIPHistory: apiPrefix + '/PIPManagement/getPIPHistory',
  extendPip: apiPrefix + '/PIPManagement/extendPip',
  removeFromPip: apiPrefix + '/PIPManagement/removeFromPip',
  updatePipDetails: apiPrefix + '/PIPManagement/updatePipDetails',
  savePIPClearnceCertificate:
    apiPrefix + '/PIPManagement/savePIPClearnceCertificate',
}
export const AppraisalTemplateApiConfig: AppraisalTemplateApi = {
  cycle: apiPrefix + '/appraisal/cycle',
  activeCycle: apiPrefix + '/appraisal/activeCycle',
  getDesignationsUnderCycle: apiPrefix + '/appraisal/getDesignationsUnderCycle',
  getDesignationWiseKRAs: apiPrefix + '/kra/getDesignationWiseKRAs',
  checkedUnderKras: apiPrefix + '/appraisal/underKras',
  searchKRAData: apiPrefix + '/kra/searchKRAData',
  kpisForIndividualKra: apiPrefix + '/kra/kpisForIndividualKra',
  designingmaping: apiPrefix + '/kra/designingmaping',
}
export const projectStatusApiConfig: ProjectStatusApi = {
  statusReportLis: apiPrefix + '/project-mgmt/statusReportList',
  addStatusReport: apiPrefix + '/project-mgmt/statusReports',
  deleteStatusReport: apiPrefix + '/project-mgmt/statusReportDelete',
  updateStatusReport: apiPrefix + '/project-mgmt/updateStatusreport',
}
export const processAreaApiConfig: ProcessAreaListApi = {
  getProjectTailoringDocument:
    apiPrefix + '/projectTailoring/getProjectTailoringDocument',
  getProcessAreas: apiPrefix + '/projectTailoring/getProcessAreas',
  createProcessArea: apiPrefix + '/projectTailoring/createProcessArea',
  checkDuplicateProcess: apiPrefix + '/projectTailoring/checkDuplicateProcess',
  saveProcessArea: apiPrefix + '/projectTailoring/saveProcessArea',
  incrementOrDecrementOrder:
    apiPrefix + '/projectTailoring/incrementOrDecrementOrder',
  getOrderCountOfActiveProcesses:
    apiPrefix + '/projectTailoring/getOrderCountOfActiveProcesses',
  getProcessAreaDetails: apiPrefix + '/projectTailoring/getProcessAreaDetails',
  checkforDuplicateDoc: apiPrefix + '/projectTailoring/checkforDuplicateDoc',
}
export const addNewAuditApiConfig: AddNewAudit = {
  saveNewAuditForm: apiPrefix + '/sqaAuditController/saveOrSubmitAuditForm',
  editAuditFormDetails: apiPrefix + '/sqaAuditController/getAuditDetails',
  getProjectEmployees: apiPrefix + '/allocation-mgmt/getProjectEmployees',
  updateSQAAuditForm: apiPrefix + '/sqaAuditController/updateAuditForm',
}
export const sqaAuditReportApiConfig: SQAAuditReportApi = {
  getSQAAuditReport: apiPrefix + '/sqaAuditController/getSQAAuditReport',
  exportSqaAuditReport: apiPrefix + '/sqaAuditController/exportSqaAuditReport',
  deleteProjectAuditDetails:
    apiPrefix + '/sqaAuditController/deleteProjectAuditDetails',
  closeAudit: apiPrefix + '/sqaAuditController/closeAudit',
  getNewSQAAuditTimelineDetails:
    apiPrefix + '/sqaAuditController/getNewSQAAuditTimelineDetails',
  getAuditDetails: apiPrefix + '/sqaAuditController/getAuditDetails',
  saveOrSubmitAuditForm:
    apiPrefix + '/sqaAuditController/saveOrSubmitAuditForm',
  downloadSQAAuditFile: apiPrefix + '/sqaAuditController/downloadSQAAuditFile',
  uploadSQAAuditFiles: apiPrefix + '/fileUpload/uploadSQAAuditFiles',
}
export const notificationsApiConfig: NotificationsApi = {
  allAlerts: apiPrefix + '/alert/allAlerts',
  updateAlert: apiPrefix + '/alert/updateAlert',
}
export const jobOpeningsApiConfig: JobOpeningsApi = {
  getAllJobVacancies: apiPrefix + '/jobvacancy/getAllJobVacancies',
  getAllTechnology: apiPrefix + '/jobapplicant/getAllTechnology',
  addJobVacancy: apiPrefix + '/jobvacancy/jobAdmin/addJobVacancy',
  deleteJobVacancy: apiPrefix + '/jobvacancy/jobAdmin/deleteJobVacancy',
  getJobOpeningById: apiPrefix + '/jobapplicant/getJobOpeningById',
  getJobVacancyAudit: apiPrefix + '/jobvacancy/getJobVacancyAudit',
  updateJobVacancy: apiPrefix + '/jobvacancy/jobAdmin/updateJobVacancy',
  isCandidateMappedWithJob:
    apiPrefix + '/jobapplicant/jobAdmin/isCandidateMappedWithJob',
  getActiveVendorsList: apiPrefix + '/assetManagement/getActiveVendorsList',
  editVendorJobDetails: apiPrefix + '/jobvacancy/editVendorJobDetails',
}

export const resumeMatcherApiConfig: ResumeMatcherApi = {
  addResumesMatchingData: apiPrefix + '/jobapplicant/addResumesMatchingData',
  matchResumesBatch: aiApiPrefix + '/match-resumes-batch/',
  uploadResumes: apiPrefix + '/jobapplicant/uploadResumes',
  getAllResumesMatchingData:
    apiPrefix + '/jobapplicant/getAllResumesMatchingData',
  exportResumesMatchingData:
    apiPrefix + '/jobapplicant/exportResumesMatchingData',
  getExternalVendorCompanyNames:
    apiPrefix + '/jobapplicant/getExternalVendorCompanyNames',
  getResumesPath: apiPrefix + '/jobapplicant/getResumePath',
}

export const vendorListApiConfig: VendorListApi = {
  getAllVendorDetails: apiPrefix + '/assetManagement/getAllVendorDetails',
  getDepartmentNameList: apiPrefix + '/assetManagement/getDepartmentNameList',
  addVendorDetails: apiPrefix + '/assetManagement/addVendorDetails',
  exportVendorData: apiPrefix + '/assetManagement/exportVendorList',
  deleteVendorDetails: apiPrefix + '/assetManagement/deleteVendorDetails',
  editVendorDetails: apiPrefix + '/assetManagement/updateVendorDetails',
  isVendorUserExist: apiPrefix + '/assetManagement/isUserExist',
}

export const ChangeReporteesAPiConfig: ChangeReporteesApi = {
  getAllReportingManagerData:
    apiPrefix + '/delegation/getAllReportingManagerData',
  getAllHRList: apiPrefix + '/delegation/getAllHRList',
  getEmployeesUnderManger: apiPrefix + '/delegation/getMangerUnderEmployees',
  getHrAssociates: apiPrefix + '/delegation/getHrAssociates',
  updateReportingManager: apiPrefix + '/delegation/updateReportingManager',
  updateHrAssociatesManager: apiPrefix + '/delegation/updateHrAssociates',
}
export const ManufacturerApiListConfig: ManufacturerApi = {
  getAllManufacturerName: apiPrefix + '/assetManagement/getAllManufacturerName',
  exportManufacturerList: apiPrefix + '/assetManagement/exportManufacturerList',
  getAllLookUps: apiPrefix + '/assetManagement/getAllLookUps',
  addManufacturer: apiPrefix + '/assetManagement/addManufacturer',
  deleteManufacturerName: apiPrefix + '/assetManagement/deleteManufacturerName',
  updateManufacturerName: apiPrefix + '/assetManagement/updateManufacturerName',
}
export const GetProductTypeListConfig: ProductTypeListApi = {
  getProductTypeList: apiPrefix + '/assetManagement/getAllProductTypes',
  deleteProduct: apiPrefix + '/assetManagement/deleteProduct',
  exportProductList: apiPrefix + '/assetManagement/exportProductList',
  getAllLookUps: apiPrefix + '/assetManagement/getAllLookUps',
  addProduct: apiPrefix + '/assetManagement/addProduct',
  updateProduct: apiPrefix + '/assetManagement/updateProduct',
}
export const assetWarrantyReportConfig: AssetWarrantyReportApi = {
  getWarrantyAssetsList: apiPrefix + '/assetManagement/getWarrantyAssetsList',
  downloadExportAssetWarrantyList:
    apiPrefix + '/assetManagement/exportAssetWarrantyList',
}
export const assetTransactionListConfig: AssetTransationListApi = {
  getAssetTransactionList:
    apiPrefix + '/assetManagement/getTransactionalHistory',
  getAssetHistory: apiPrefix + '/assetManagement/getAssetHistory',
  exportAssetTransactionalHistory:
    apiPrefix + '/assetManagement/exportAssetTransactionalHistory',
}
export const categoryListApiConfig: CategoryListApi = {
  getCategoryList: apiPrefix + '/ExpenseManagement/getCategoryList',
  addCategory: apiPrefix + '/ExpenseManagement/addCategory',
  checkForDuplicateCategory:
    apiPrefix + '/ExpenseManagement/checkForDuplicateCategory',
  editCategory: apiPrefix + '/ExpenseManagement/editCategory',
  updateCategory: apiPrefix + '/ExpenseManagement/updateCategory',
  deleteCategory: apiPrefix + '/ExpenseManagement/deleteCategory',
}

export const IntervieweeDetailsApiConfig: IntervieweeDetailsApi = {
  timelinedetails: apiPrefix + '/jobapplicant/timelinedetails',
  saveInitialComments: apiPrefix + '/jobapplicant/jobAdmin/saveInitialComments',
  updateCandidateInterviewStatus:
    apiPrefix + '/jobapplicant/jobAdmin/updateCandidateInterviewStatus',
  empScheduleInterviewDetails:
    apiPrefix + '/jobapplicant/empScheduleInterviewDetails',
  updateInterview: apiPrefix + '/jobapplicant/jobAdmin/updateInterview',
  getAllEmployeeDetails: apiPrefix + '/jobapplicant/getAllEmployeeDetails',
  interviewRoundCount: apiPrefix + '/jobapplicant/interviewRoundCount',
  reScheduleInterview: apiPrefix + '/jobapplicant/jobAdmin/reScheduleInterview',
  scheduleInterview: apiPrefix + '/jobapplicant/jobAdmin/scheduleInterview',
  checkEmployeeAvailability:
    apiPrefix + '/jobapplicant/checkEmployeeAvailability',
  sendRejectedMessagetoCandidate:
    apiPrefix + '/jobapplicant/sendRejectedMessagetoCandidate',
  uploadCandidateImage: apiPrefix + '/jobapplicant/uploadCandidateImage',
}
export const CandidateListApiConfig: CandidateListApi = {
  searchScheduledCandidate:
    apiPrefix + '/jobapplicant/jobAdmin/searchScheduledCandidate',
  getEmpCountries: apiPrefix + '/jobapplicant/getEmpCountries',
  getAllTechnology: apiPrefix + '/jobapplicant/getAllTechnology',
  getCountryWiseCandidatesList:
    apiPrefix + '/jobapplicant/jobAdmin/getCountryWiseCandidatesList',
  deleteCandidate: apiPrefix + '/jobapplicant/jobAdmin/deleteCandidate',
  getAllJobVacanciesList: apiPrefix + '/jobvacancy/getAllJobVacancies',
  getAllEmployeeDetails: apiPrefix + '/jobapplicant/getAllEmployeeDetails',
  checkCandidateEmail: apiPrefix + '/jobapplicant/checkeamil',
  checkCandidateMobileNumber:
    apiPrefix + '/jobapplicant/isCandidateMobileNumberExists',
  getAllCompaniesData: apiPrefix + '/jobapplicant/getAllCompaniesData',
  addNewCandidate: apiPrefix + '/jobapplicant/jobAdmin/addNewCandidate',
  uploadCandidateResume: apiPrefix + '/fileUpload/uploadCandidateResume',
  addTechnology: apiPrefix + '/jobapplicant/addtechnology',
  deleteTechnology: apiPrefix + '/jobapplicant/deleteTechnology',
  editCandidateData: apiPrefix + '/jobapplicant/jobAdmin/editCandidate',
  isEditCandidateMailExists:
    apiPrefix + '/jobapplicant/isEditCandidateMailExists',
  isEditCandidateMobileNumberExists:
    apiPrefix + '/jobapplicant/isEditCandidateMobileNumberExists',
  editNewCandidate: apiPrefix + '/jobapplicant/jobAdmin/editNewCandidate',
  downloadFile: apiPrefix + '/jobapplicant/downloadFile',
  uploadBulkOfCandidates: apiPrefix + '/jobapplicant/uploadBulkOfCandidates',
  exportCandidateList: apiPrefix + '/jobapplicant/exportCandidateList',
  recritersDetails: apiPrefix + '/jobapplicant/getAllRecritersDetails',
  getInterviewCandidatesList:
    apiPrefix + '/jobapplicant/jobAdmin/getInterviewCandidatesList',
  exportInterviewCandidatesList:
    apiPrefix + '/jobapplicant/exportInterviewCandidatesList',
  resumeCandidateList: aiApiPrefix + '/upload-resume/',
  getAllStatus: apiPrefix + '/jobapplicant/getAllStatus',
}

export const GetAssetListConfig: AssetListApi = {
  getAllLookUps: apiPrefix + '/assetManagement/getAllLookUps',
  getAssetTypeChange: apiPrefix + '/assetManagement/getassetTypeChangeList',
  getAllAssets: apiPrefix + '/assetManagement/getAllAssets',
  getAssetHistory: apiPrefix + '/assetManagement/getAssetHistory',
  exportAssetList: apiPrefix + '/assetManagement/exportAssetList',
}

export const changeAssetStatusConfig: ChangeAssetStatusReportApi = {
  saveEmployee: apiPrefix + '/assetManagement/saveEmployee',
  getAllAssets: apiPrefix + '/assetManagement/getAllAssets',
}
export const ProductSpecificationListReportApiConfig: ProductSpecificationListApi =
  {
    getAllProductSpecifications:
      apiPrefix + '/assetManagement/getAllProductSpecifications',
    getAllLookUps: apiPrefix + '/assetManagement/getAllLookUps',
    getassetTypeChangeList:
      apiPrefix + '/assetManagement/getassetTypeChangeList',
    getProductTypeChangeList:
      apiPrefix + '/assetManagement/getProductTypeChangeList',
    exportProductSpecificationList:
      apiPrefix + '/assetManagement/exportProductSpecificationList',
    addProductSpecifications:
      apiPrefix + '/assetManagement/addProductSpecifications',
    updateProductSpecification:
      apiPrefix + '/assetManagement/updateProductSpecification',
    deleteProductSpecification:
      apiPrefix + '/assetManagement/deleteProductSpecification',
  }
export const getAddAssetListConfig: AddAssetListApi = {
  addAsset: apiPrefix + '/assetManagement/addAsset',
  updateAsset: apiPrefix + '/assetManagement/updateAssetDetails',
  getCopyAssetList: apiPrefix + '/assetManagement/getCopyAssetList',
  checkAssetNumberExixts: apiPrefix + '/assetManagement/checkAssetNumberExixts',
  typeChangeSpecifications:
    apiPrefix + '/assetManagement/typeChangeSpecifications',
}
export const CompaniesListApiConfig: CompaniesListApi = {
  getAllCompanies: apiPrefix + '/jobapplicant/getAllCompanies',
  exportCompaniesList: apiPrefix + '/jobapplicant/exportCompaniesList',
  getAllCandidatesInfo: apiPrefix + '/jobapplicant/getAllCandidatesInfo',
  getAllEmployeesInfo: apiPrefix + '/jobapplicant/getAllEmployeesInfo',
}

export const MyProfileSeparationApiConfig: MyProfileSeparationApi = {
  getEmployeeSeparationForm:
    apiPrefix + '/separationController/getEmployeeSeparationForm',
  separationDownloadForm: apiPrefix + '/separationController/downloadForm',
  separationDownloadFile: apiPrefix + '/separationController/downloadFile',
  checkExitFeedBackForm:
    apiPrefix + '/separationController/checkExitFeedBackForm',
}
export const ExpenseSubCategoryListApiConfig: ExpenseSubCategoryListApi = {
  getCategoryList: apiPrefix + '/ExpenseManagement/getCategoryList',
  getSubCategoryList: apiPrefix + '/ExpenseManagement/getSubCategoryList',
  addSubCategoryList: apiPrefix + '/ExpenseManagement/addSubCategory',
  editSubCategory: apiPrefix + '/ExpenseManagement/editSubCategory',
  checkForDuplicateSubCategory:
    apiPrefix + '/ExpenseManagement/checkForDuplicateSubCategory',
  updateSubCategory: apiPrefix + '/ExpenseManagement/updateSubCategory',
  deleteSubCategory: apiPrefix + '/ExpenseManagement/deleteSubCategory',
}

export const CreditCardListApiConfig: CreditCardListApi = {
  getCardsList: apiPrefix + '/ExpenseManagement/getCardsList',
  addCardDetails: apiPrefix + '/ExpenseManagement/addCardDetails',
  editCardDetails: apiPrefix + '/ExpenseManagement/editCardDetials',
  updateCardDetails: apiPrefix + '/ExpenseManagement/updateCardDetails',
  deleteCardData: apiPrefix + '/ExpenseManagement/deleteCardData',
  checkDuplicateCardNumber:
    apiPrefix + '/ExpenseManagement/checkDuplicateCardNumber',
}
export const getUpComingJoinListConfig: UpComingJoinListApi = {
  getUpcomingJoineeList: apiPrefix + '/jobapplicant/getUpcomingJoineeList',
  getEmployeeDepartments: apiPrefix + '/assetManagement/getEmpDepartments',
  getJoineeById: apiPrefix + '/jobapplicant/getJoineeById',
  deleteJoinee: apiPrefix + '/jobapplicant/jobAdmin/deleteJoinee',
  getUpdateNewJoinee: apiPrefix + '/jobapplicant/updateNewJoinee',
  getTechnologies: apiPrefix + '/jobapplicant/getAllTechnology',
  downloadJoineeFile: apiPrefix + '/jobapplicant/downloadAttachment',
  exportUpcomingJoineeList:
    apiPrefix + '/jobapplicant/exportUpcomingJoineeList',
}

export const expenseFormApiConfig: ExpenseFormApi = {
  getEmployeeList: apiPrefix + '/jobapplicant/getAllProfileEmployeesData',
  getCurrencyList: apiPrefix + '/ExpenseManagement/getCurrencyList',
  getCategoryList: apiPrefix + '/ExpenseManagement/getCategoryList',
  getEmpDepartments: apiPrefix + '/assetManagement/getEmpDepartments',
  getPaymentList: apiPrefix + '/ExpenseManagement/getPaymentList',
  getCountries: apiPrefix + '/ExpenseManagement/getCountries',
  getSubCategories: apiPrefix + '/ExpenseManagement/getSubCategories',
  editCategory: apiPrefix + '/ExpenseManagement/editCategory',
  getMatchedProjects: apiPrefix + '/ExpenseManagement/getMatchedProjects',
  getVendorList: apiPrefix + '/ExpenseManagement/getVendorList',
  getCardsList: apiPrefix + '/ExpenseManagement/getCardsList',
  addExpenses: apiPrefix + '/ExpenseManagement/addExpenses',
}
export const getCandidateOfferConfig: CandidateOfferApi = {
  getpersontechnology: apiPrefix + '/jobapplicant/getpersontechnology',
  getCandidateDesignation: apiPrefix + '/kra/designation',
  getAddNewJoinee: apiPrefix + '/jobapplicant/addNewJoinee',
  getEmpDepartments: apiPrefix + '/assetManagement/getEmpDepartments',
  getUploadFileForNewJoinee: apiPrefix + '/jobapplicant/uploadFileForNewJoinee',
}
export const interviewStatusReportApiConfig: InterviewStatusReportApi = {
  getAllEmpCountries: apiPrefix + '/jobapplicant/getEmpCountries',
  getAllTechnology: apiPrefix + '/jobapplicant/getAllTechnology',
  getInterviewStatusReport:
    apiPrefix + '/jobapplicant/jobAdmin/interviewStatusReport',
  exportInterviewStatusReport:
    apiPrefix + '/jobapplicant/exportInterviewStatusReport',
  exportInterviewerDetails:
    apiPrefix + '/jobapplicant/exportInterviewerDetails',
  getStatusChart: apiPrefix + '/jobapplicant/getStatusChart',
}

export const CheckListApiConfig: ChecklistApi = {
  getCheckList: apiPrefix + '/contactInfo/getAll',
  getChecklistItem: apiPrefix + '/contactInfo/get',
  getEmpDepartments: apiPrefix + '/assetManagement/getEmpDepartments',
  addPage: apiPrefix + '/contactInfo/add',
  updateHandbookItem: apiPrefix + '/contactInfo/updateHandbookItem',
  deletePage: apiPrefix + '/contactInfo/delete',
}

export const expensesTimeLineApiConfig: ExpensesTimeLineApi = {
  getExpenseAudit: apiPrefix + '/ExpenseManagement/getExpenseAudit',
}
export const expensesListApiConfig: ExpensesListApi = {
  getEmpDepartments: apiPrefix + '/assetManagement/getEmpDepartments',
  getCategoryList: apiPrefix + '/ExpenseManagement/getCategoryList',
  getCountries: apiPrefix + '/ExpenseManagement/getCountries',
  getPaymentList: apiPrefix + '/ExpenseManagement/getPaymentList',
  getExpensesList: apiPrefix + '/ExpenseManagement/getExpensesList',
  getSelectedSubCategories:
    apiPrefix + '/ExpenseManagement/getSelectedSubCategories',
  exportExpenseList: apiPrefix + '/ExpenseManagement/exportExpenseList',
  getCurrencyList: apiPrefix + '/ExpenseManagement/getCurrencyList',
  getExpenseDetails: apiPrefix + '/ExpenseManagement/getExpenseDetails',
  editCategory: apiPrefix + '/ExpenseManagement/editCategory',
  getSubCategories: apiPrefix + '/ExpenseManagement/getSubCategories',
  updateExpenses: apiPrefix + '/ExpenseManagement/updateExpenses',
  getMatchedProjects: apiPrefix + '/ExpenseManagement/getMatchedProjects',
  getVendorList: apiPrefix + '/ExpenseManagement/getVendorList',
  getEmployeeList: apiPrefix + '/jobapplicant/getAllProfileEmployeesData',
  getCardsList: apiPrefix + '/ExpenseManagement/getCardsList',
  updateExpensesList: apiPrefix + '/ExpenseManagement/updateExpenses',
  deleteExpense: apiPrefix + '/ExpenseManagement/deleteExpense',
  addCopiedExpensesList: apiPrefix + '/ExpenseManagement/addCopiedExpensesList',
}

export const paymentListApiConfig: PaymentListApi = {
  getDepartments: apiPrefix + '/assetManagement/getEmpDepartments',
  getCategoryList: apiPrefix + '/ExpenseManagement/getCategoryList',
  getCountries: apiPrefix + '/ExpenseManagement/getCountries',
  getPaymentList: apiPrefix + '/ExpenseManagement/getPaymentList',
  getCardsList: apiPrefix + '/ExpenseManagement/getCardsList',
  getReimbursementExpenseList:
    apiPrefix + '/ExpenseManagement/getReimbursementExpenseList',
  getExpenseDetails: apiPrefix + '/ExpenseManagement/getExpenseDetails',
  savePaymentForm: apiPrefix + '/ExpenseManagement/savePaymentForm',
  getExpensePaymentList: apiPrefix + '/ExpenseManagement/getExpensePaymentList',
  payAllAtOnce: apiPrefix + '/ExpenseManagement/payAllAtOnce',
}

export const expensesYearlyReportApiConfig: ExpenseYearlyReport = {
  getExpensesYearlyReport:
    apiPrefix + '/ExpenseManagement/getExpensesYearlyReport',
  getContries: apiPrefix + '/ExpenseManagement/getCountries',
  getMonthWiseExpenseList:
    apiPrefix + '/ExpenseManagement/getMonthWiseExpenseList',
}
export const sectionsApiConfig: SectionsApi = {
  getDepartments: apiPrefix + '/checklist/getDepartments',
  getEmpDepartments: apiPrefix + '/handbookItem/getEmpDepartments',
  getSections: apiPrefix + '/checklist/getSections',
  isSectionExist: apiPrefix + '/checklist/isSectionExist',
  saveSection: apiPrefix + '/checklist/saveSection',
  editSection: apiPrefix + '/checklist/editSection',
  deleteSection: apiPrefix + '/checklist/deleteSection',
}
export const remittanceDetailsApiConfig: RemittanceApi = {
  getRemittanceList: apiPrefix + '/remittance/',
  getCurrency: apiPrefix + '/remittance/',
  addCurrency: apiPrefix + '/remittance/addCurrency',
  deleteCurrency: apiPrefix + '/remittance/deleteCurrency',
  addRemittanceDetails: apiPrefix + '/remittance/',
  editRemittanceDetails: apiPrefix + '/remittance/',
}

export const invoicelocationListApiConfig: LocationInvoiceListApi = {
  getRemittanceList: apiPrefix + '/remittance/',
  getLocationList: apiPrefix + '/remittance/addLocation',
  deleteLocationList: apiPrefix + '/remittance/deleteLocation',
}

export const AddBankApiConfig: addBankListApi = {
  remittance: apiPrefix + '/remittance/',
  addBank: apiPrefix + '/remittance/addBank',
  deleteBank: apiPrefix + '/remittance/deleteBank',
}

export const addInvoiceApiConfig: AddInvoiceApi = {
  getNumbersAndPercentage: apiPrefix + '/project-mgmt/getNumbersAndPercentage',
  addInvoice: apiPrefix + '/invoice',
  projectData: apiPrefix + '/invoice/projectData',
  lookup: apiPrefix + '/invoice/lookup',
  clientInvoiceCountry: apiPrefix + '/invoice/invoiceNumber',
  getInvoiceSerialNumber: apiPrefix + '/invoice/getInvoiceSerialNumber',
  invoiceEdit: apiPrefix + '/invoice/invoiceEdit',
  getNumbersAndPercentageForProjectNumbers:
    apiPrefix + '/project-mgmt/getNumbersAndPercentage',
  getNumbersAndPercentageForChangeRequestNumbers:
    apiPrefix + '/project-mgmt/getNumbersAndPercentage',
  invoiceCountryBaseApi: apiPrefix + '/invoice/checkInvoiceNumbe',
  getInvoiceStatusHistoryById:
    apiPrefix + '/invoice/getInvoiceStatusHistoryById',
  deleteInvoiceId: apiPrefix + '/invoice/deleteInvoice',
  getByRole: apiPrefix + '/invoice/getByRole',
  updateInvoice: apiPrefix + '/invoice/',
  checkInvoiceNumber: apiPrefix + '/invoice/checkInvoiceNumber',
  getWireTransferInstructions:
    apiPrefix + '/invoice/getwireTransferInstructions',
  deletePartialReceivedAmount:
    apiPrefix + '/invoice/deletePartiallyReceivedAmount',
  checkSerialNumber: apiPrefix + '/invoice/checkInvoiceNumberExits',
  checkMilestoneExits: apiPrefix + '/invoice/checkMilestoneExits',
  invoiceMileStones: apiPrefix + '/project-mgmt/mileStones',
  raisedCRPercentage: apiPrefix + '/project-mgmt/getRaisedCRPercentage',
  getInvoiceDetails: apiPrefix + '/invoice/getinvoiceDetails',
  getInvoicePDF: apiPrefix + '/getRetainerPDF',
  allowToAdjustInvoice: apiPrefix + '/invoice/allowToAdjustInvoice',
  restrictToAdjustInvoice: apiPrefix + '/invoice/restrictToAdjustInvoice',
}
export const CountryApiConfig: countryApi = {
  addCountry: apiPrefix + '/invoice/addCountry',
  getCountries: apiPrefix + '/invoice/getCountryLookup',
  deleteCountry: apiPrefix + '/invoice/deleteCountry',
}

export const AdderessListApiConfig: AdderessListApi = {
  getAddressDetailsList: apiPrefix + '/invoice/getAddressDetailsList',
  deleteAddressDetails: apiPrefix + '/invoice/deleteAddressDetails',
  updateAddress: apiPrefix + '/invoice/updateAddress',
  addAddress: apiPrefix + '/invoice/addAddress',
  getCountryLookup: apiPrefix + '/invoice/getCountryLookup',
}
export const clientInvoiceReportApiConfig: ClientInvoiceReport = {
  clientInvoiceAudit: apiPrefix + '/invoice/clientInvoiceAudit',
  getClients: apiPrefix + '/project-mgmt/getClients',
  clientsProjectsAudit: apiPrefix + '/invoice/clientsProjectsAudit',
  clientsProjectInvoicesAudit:
    apiPrefix + '/invoice/clientsProjectInvoicesAudit',
  getInvoiceSummary: apiPrefix + '/invoice/getInvoiceSummary',
}

export const projectNumbersApiConfig: ProjectNumbersTab = {
  getProjectNumbers: apiPrefix + '/project-mgmt/getProjectNumbers',
  getCurrencyList: apiPrefix + '/project-mgmt/getCurrencyList',
  projectNumbers: apiPrefix + '/project-mgmt/projectNumbers',
  getCRLookUpForNumbers: apiPrefix + '/project-mgmt/getCRLookupforNumbers',
  changeRequestNumbers: apiPrefix + '/project-mgmt/projectNumbers',
  updateProjectNumbers: apiPrefix + '/project-mgmt/updateProjectNumbers',
  updateCRNumbers: apiPrefix + '/project-mgmt/updateCRNumbers',
}

export const AddTaxApiConfig: addTaxListApi = {
  lookup: apiPrefix + '/invoice/lookup',
  country: apiPrefix + '/invoice/getAllTaxRelatedToCuntry',
  saveAllTax: apiPrefix + '/invoice/saveAllTax',
  updateTax: apiPrefix + '/invoice/updateTax',
  deleteTax: apiPrefix + '/invoice/deleteTax',
}
export const invoiceHistoryDetailsApiConfig: invoiceTimeLineApi = {
  invoiceHistory: apiPrefix + '/invoice/Audit',
}

export const InvoiceDiscussionApiConfig: invoiceDiscussionListApi = {
  invoiceDetailsForDiscussion:
    apiPrefix + '/invoice/invoiceDetailsForDiscussion',
  invoiceNewsFeed: apiPrefix + '/projectnewsfeed/invoiceNewsFeed/',
  projectnewsfeed: apiPrefix + '/projectnewsfeed/',
  // uploadImage: apiPrefix + 'projectnewsfeed/uploadImage',
}

export const invoiceAuditLogListApiConfig: AuditLogInvoiceListApi = {
  getinvoiceAuditLogList: apiPrefix + '/invoice/',
  getAuditLogList: apiPrefix + '/invoice/invoiceAuditLog',
}
export const addCurrencyApiConfig: GetInitDataApi = {
  getInitDataApi: apiPrefix + '/invoice/getInitData',
  addCurrencyDetails: apiPrefix + '/invoice/addInrToCurrency',
  updateCurrencyDetails: apiPrefix + '/invoice/updateInrToCurrency',
}
export const InvoiceAuditReportApiConfig: invoiceAuditReportApi = {
  invoiceAuditList: apiPrefix + '/invoice/invoiceAuditList',
  getCountryLookup: apiPrefix + '/invoice/getCountryLookup',
}
export const ProjectMilestoneApiConfig: ProjectMilestonesApi = {
  getClients: apiPrefix + '/project-mgmt/getClients',
  billingReportonSearch: apiPrefix + '/project-mgmt/billingReportonSearch',
  reOpenMilestone: apiPrefix + '/project-mgmt/reOpenMilestone',
  billingReport: apiPrefix + '/project-mgmt/billingReport',
}

export const InvoicesListApiConfig: invoiceListApi = {
  invoiceList: apiPrefix + '/invoice/invoiceList',
  getCountryLookup: apiPrefix + '/invoice/getCountryLookup',
  exportInvoicesList: apiPrefix + '/invoice/exportInvoiceList',
}

export const invoiceSendReminderListApiConfig: InvoicesSendReminderListApi = {
  getReminderDescription: apiPrefix + '/invoice/getReminderDescription',
  getReminderLogs: apiPrefix + '/invoice/getReminderLogs',
  invoiceReminderlog: apiPrefix + '/invoice/invoiceReminderlog',
}
export const InvoiceSummaryApiConfig: InvoiceSummaryApi = {
  getClients: apiPrefix + '/project-mgmt/getClients',
  getProjects: apiPrefix + '/invoicesummary/getProjects',
  getInvoiceSummary: apiPrefix + '/invoicesummary/getInvoiceSummary',
  getSentInvoices: apiPrefix + '/invoicesummary/getSentInvoices',
  getInvoiceSummaryInCSV: apiPrefix + '/invoicesummary/getInvoiceSummaryInCSV',
}
export const invoiceReportListApiConfig: InvoicesReportListApi = {
  getCountryLookup: apiPrefix + '/invoice/getCountryLookup',
  yearlyInvoiceAudit: apiPrefix + '/invoice/yearlyInvoiceAudit',
  mopnthlyInvoiceAudit: apiPrefix + '/invoice/mopnthlyInvoiceAudit',
  projectFinancialList: apiPrefix + '/invoice/projectFinancialList',
  getInvoiceSummary: apiPrefix + '/invoice/getInvoiceSummary',
}
export const InvoiceVersionListApiConfig: InvoiceVersionListApi = {
  getInvoiceVersions: apiPrefix + '/invoice/getInvoiceVersions',
}
export const employeeProfileApiConfig: EmployeeProfileApi = {
  loggedInEmployeeData: apiPrefix + '/jobapplicant/loggedInEmployeeData',
}
export const internDetailsApiConfig: InternDetailsApi = {
  getInternDetails: apiPrefix + '/jobapplicant/getAllInternsData',
  addInternDetails: apiPrefix + '/jobapplicant/jobAdmin/addNewIntern',
  editInternDetails: apiPrefix + '/jobapplicant/jobAdmin/editIntern',
  // Topic Screen
  addTopic: apiPrefix + '/jobapplicant/addTopic',
  getAllTopics: apiPrefix + '/jobapplicant/getAllTopics',
  deleteTopic: apiPrefix + '/jobapplicant/deleteTopic',
  // Look Up Screenin
  addEmployeeName: apiPrefix + '/jobapplicant/addEmployeeName',
  getAllEmployeeNames: apiPrefix + '/jobapplicant/getEmployeeNames',
  deleteEmployeeName: apiPrefix + '/jobapplicant/deleteEmployeeName',

  getAllCollegeNames: apiPrefix + '/jobapplicant/getInternColleges',
  exportInternDetails: apiPrefix + '/jobapplicant/exportInternsData',
  internTimelineDetails: apiPrefix + '/jobapplicant/getInternProfileHistory',
}

export const accessCardDetailsApiConfig: AccessCardDetailsApi = {
  getAccessCardsList: apiPrefix + '/assetManagement/getAccessCardsList',
  exportAccessCardsList: apiPrefix + '/assetManagement/exportAccessCardsList',
}

export const lateArrivalReportApiConfig: LateArrivalReportApi = {
  getEmployeeLateComings: apiPrefix + '/biometric/getEmployeeLateComings',
}

export const attendanceRegularizationApiConfig: AttendanceRegularizationApi = {
  getRegularizationForManager:
    apiPrefix + '/biometric/getRegularizationsForManager',
  approveRequest: apiPrefix + '/biometric/approveRequest ',
  cancelRequest: apiPrefix + '/biometric/cancelRequest ',
  rejectRequest: apiPrefix + '/biometric/rejectRequest',
  checkProjectManagerExits: apiPrefix + '/biometric/checkProjectManagerExits',
  downloadRegularizationFile:
    apiPrefix + '/biometric/downloadRegularizationFile',
  uploadRegularizationFile:
    apiPrefix + '/jobapplicant/uploadRegularizationFile',
}

export const employeeApplyLateApiConfig: ApplyLateArrivalApi = {
  regularization: apiPrefix + '/biometric/attendance/regularization ',
}

export const pmoConfigurationApiConfig: PmoConfigurationApi = {
  getAllPMO: apiPrefix + '/project-mgmt/getAllPMOsList',
  addPmoConfig: apiPrefix + '/project-mgmt/pmo-config',
  deletePmoConfig: apiPrefix + '/project-mgmt/pmo-delete',
  isPMO: apiPrefix + '/project-mgmt/isPMO',
}
export const formSixteenDownloadApiConfig: formSixteenDownloadApi = {
  downloadFormSixteenFile: apiPrefix + '/itDeclaration/downloadForm16File',
}

export const formSixteenUploadApiConfig: formSixteenUploadApi = {
  uploadForm16: apiPrefix + '/itDeclaration/uploadForm16',
  getForm16Files: apiPrefix + '/itDeclaration/getForm16Files',
  deleteCheckedForm16Files:
    apiPrefix + '/itDeclaration/deleteCheckedForm16Files',
  deleteSingleForm16Files: apiPrefix + '/itDeclaration/deleteForm16Files',
}
export const complianceReminderApiConfig: ComplianceReminderApi = {
  addNewCompliance: apiPrefix + '/compliance/addNewCompliance',
  getAllComplianceDetails: apiPrefix + '/compliance/getAllCompliancesDetails',
  deleteComplianceDetails: apiPrefix + '/compliance/deleteComplianceDetails',
  updateCompliance: apiPrefix + '/compliance/updateCompliance',
  uploadComplianceFile: apiPrefix + '/compliance/uploadComplianceFile',
  editComplianceTask: apiPrefix + '/compliance/editComplianceTask',
  downloadCompliance: apiPrefix + '/compliance/downloadCompliance',
  getAllTasksUnderCompliance:
    apiPrefix + '/compliance/getAllTasksUnderCompliance',
  getComplianceHistory: apiPrefix + '/compliance/getComplianceHistory',
  getDepartmentWiseEmployeesList:
    apiPrefix + '/jobapplicant/getDepartmentWiseEmployeesList',
  exportCompliance: apiPrefix + '/compliance/exportCompliance',
  getUpcomingComplianceDueDates:
    apiPrefix + '/compliance/getUpcomingComplianceDueDates',
  getDepartmentList: apiPrefix + '/compliance/getDepartmentList',
}

export const interviewerConfigurationApiConfig: InterviewerConfigurationApi = {
  getDepartmentWiseEmployeesList:
    apiPrefix + '/jobapplicant/getDepartmentWiseEmployeesList',
  addInterviewerDetails: apiPrefix + '/jobapplicant/addInterviewerDetails',
  getAllJobCodes: apiPrefix + '/jobvacancy/getAllJobCodes',
  getAllInterviewersDetails:
    apiPrefix + '/jobapplicant/getAllInterviewersDetails',
  updateInterviewerDetails:
    apiPrefix + '/jobapplicant/updateInterviewerDetails',
  deleteInterviewerDetails:
    apiPrefix + '/jobapplicant/deleteInterviewerDetails',
  deleteCheckedInterviewerDetails:
    apiPrefix + '/jobapplicant/deleteCheckedInterviewerDetails',
  isInterviewerAvailable: apiPrefix + '/jobapplicant/isInterviewerAvailable',
}
export const sowApiConfig: SowApi = {
  uploadProjectSOW: apiPrefix + '/project-mgmt/uploadProjectSOW',
  downloadSOWFile: apiPrefix + '/project-mgmt/downloadSOWFile',
  getSowFileData: apiPrefix + '/project-mgmt/getSOWFileData',
}
export const observationApiConfig: ObservationApi = {
  addObservation: apiPrefix + '/observation-mgnt/observation',
  uploadCandidateObservation:
    apiPrefix + '/fileUpload/uploadCandidateObservation',
  activeEmployee: apiPrefix + '/observation-mgnt/activeEmployee/',
  getPerformanceRatings: apiPrefix + '/observation-mgnt/getPerformanceRatings',
  getAllObservations: apiPrefix + '/observation-mgnt/observation/',
  deleteObservation: apiPrefix + '/observation-mgnt/observation',
  updateObservation: apiPrefix + '/observation-mgnt/observation',
  downloadObservationFile: apiPrefix + '/observation-mgnt/downloadFile',
  exportObservation: apiPrefix + '/observation-mgnt/exportObservation',
}
export const festivalUploadApiConfig: festivalUploadApi = {
  uploadFestival: apiPrefix + '/Employee/uploadServerFiles',
  getAllFestivals: apiPrefix + '/Employee/getAllFestivals',
  saveFestival: apiPrefix + '/Employee/saveFestival',
  updateFestival: apiPrefix + '/Employee/updateFestival',
  deleteFestival: apiPrefix + '/Employee/deleteFestival',
  checkFestivalNameExist: apiPrefix + '/Employee/checkFestivalName',
}
